import axios from 'axios'
//import pcaworker from '@/web-worker/pca-worker'
import debounce from "lodash.debounce";
const Social = () => import("@/components/Social.vue");
import copy from 'copy-html-to-clipboard';
const SamplesModal = () => import('../components/modals/dataSamples.vue')
const EditSamplesModal = () => import('../components/modals/EditSamplesModal.vue')
import rightpanel from '@/components/RightPanel/';
import getGenoplotsamples from "@/graphql/getGenoplotsamples"
import getOwnerSamplesQuery from "@/graphql/getOwnerSamplesQuery"
import getShareQuery from "@/graphql/getShareQuery"
import getSamplesQuery from "@/graphql/getSamplesQuery"
import queryByOwnerType from "@/graphql/queryByOwnerType"
import queryGenoplotsamplesByGroup from "@/graphql/queryGenoplotsamplesByGroup"
import getS3SignatureQuery from "@/graphql/getS3SignatureQuery"
import getFilebaseSignatureQuery from "@/graphql/getFilebaseSignatureQuery"
import invokeAnalyzeResults from "@/graphql/invokeAnalyzeResults"
import {
    saveAs
} from 'file-saver';
import {
    analyzeResults
} from '@/components/methods/sharedMethods.js'
import * as markerjs2 from '@/plugins/markerjs2';
import d3 from '@plotly/d3'
markerjs2.Activator.addKey('MJS2-P186-M739-3506');
import {
    HighlightEllipseMarker
} from "@/components/ellipsehighlighter";
import {
    EllipseMarker2
} from "@/components/ellipse";
import {
    PCA
} from 'ml-pca';
import {
    Checkbox,
    Collapse,
    CollapseItem,
    Button,
    Tabs,
    TabPane
} from '@/components'
import {
    Switch,
    Input
} from 'element-ui'
import {
    Plotly
} from '@/components/plotly'
import {
    mapState
} from 'vuex'
import domtoimage from 'dom-to-image-improved';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
const dbg = console.log;

export default {
    name: 'app-page',
    bodyClass: 'app-page,pca-container',
    data() {
        return {
            rerunswitch: false,
            explaining: false,
            debouncedSearchSamples: function() {
                return []
            },
            debouncedSearchGroups: function() {
                return []
            },
            debouncedSearchGroupsPlus: function() {
                return []
            },
            filteredGroupSamples: [],
            pcamounted: false,
            topics: {},
            filteredGroupPlusSamples: [],
            filteredSamples: [],
            frameDisplay: 'none',
            activeTab: "presets",
            direction: 'rtl',
            plotlyMounted: 0,
            pcaClass: "default",
            editPCA: false,
            priorProxy: null,
            annotations: 0,
            layout: {
                annotations: [],
                "mode": "2d",
                "init": true,
                "paper_bgcolor": "#f2f2f2",
                "plot_bgcolor": "#f2f2f2",
            },
            saveReady: false,
            saveReady2: false,
            activePath: false,
            customGroups: [],
            customUserGroups: [],
            exporting: false,
            colors: [
                //"#003f5c",
                "#2f4b7c",
                "red",
                //"#665191",
                //"#a05195",
                //"#d45087",
                //"#f95d6a",
                "#ff7c43",
                "#ffa600"
            ],
            chartColors: [
                ["#1f78b4", "#a6cee3", "#33a02c", "#b2df8a", "#e31a1c", "#fb9a99", "#ff7f00", "#fdbf6f", "#6a3d9a", "#cab2d6", "#b15928", "#ffff99"],
                ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#676767"],
                ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#abdda4", "#66c2a5", "#3288bd"],
                ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
                ['#3b5998', '#F44336', '#828483', '#2e294e', '#1b998b', '#921236', '#e2c044', '#d7263d'],
                ['#a6611a', '#dfc27d', '#80cdc1', '#018571', '#d7191c', '#fdae61', '#a6d96a', '#1a9641']
            ],
            uploadIcon: {
                'width': 857.1,
                'height': 1000,
                'path': 'm214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z',
                'transform': 'matrix(1 0 0 -1 0 850)'
            },
            xplusIcon: {
                'width': 11.866216,
                'height': 7.6945963,
                'path': "M 22.773361,0.63783322 H 20.937124 V 2.4568448 H 19.993167 V 0.63783322 H 18.15693 v -0.92328619 h 1.836237 V -2.1044646 h 0.943957 v 1.81901163 h 1.836237 z M 18.741267,5.5007701 H 16.446841 L 14.788033,2.968633 13.098219,5.5007701 H 10.907145 L 13.635652,1.62505 10.963989,-2.1938262 h 2.289259 l 1.601964,2.39777885 1.648473,-2.39777885 h 2.196241 L 16.01276,1.5475356 Z",
                'transform': 'translate(-10.907145,2.1938262)'
            },
            xminusIcon: {
                'width': 11.866216,
                'height': 7.6945963,
                'path': "m 22.773361,0.63783322 h -1.836237 v 0 h -0.943957 v 0 H 18.15693 v -0.92328619 h 1.836237 v 0 h 0.943957 v 0 h 1.836237 z M 18.741267,5.5007701 H 16.446841 L 14.788033,2.968633 13.098219,5.5007701 H 10.907145 L 13.635652,1.62505 10.963989,-2.1938262 h 2.289259 l 1.601964,2.39777885 1.648473,-2.39777885 h 2.196241 L 16.01276,1.5475356 Z",
                'transform': 'translate(-10.907145,2.1938262)'
            },
            yplusIcon: {
                'width': 11.943729,
                'height': 7.6945963,
                'path': "M 22.773361,0.63783322 H 20.937124 V 2.4568448 H 19.993167 V 0.63783322 H 18.15693 v -0.92328619 h 1.836237 V -2.1044646 h 0.943957 v 1.81901163 h 1.836237 z M 18.534562,-2.1938262 15.697535,2.5242171 v 2.976553 H 13.713166 V 2.6172344 l -2.883535,-4.8110606 h 2.253085 l 1.663976,2.97655305 1.607132,-2.97655305 z",
                'transform': 'translate(-10.829631,2.1938262)'
            },
            yminusIcon: {
                'width': 11.943729,
                'height': 7.6945963,
                'path': "m 22.773361,0.63783322 h -1.836237 v 0 h -0.943957 v 0 H 18.15693 v -0.92328619 h 1.836237 v 0 l 0.943957,0 v 0 h 1.836237 z M 18.534562,-2.1938262 15.697535,2.5242171 v 2.976553 H 13.713166 V 2.6172344 l -2.883535,-4.8110606 h 2.253085 l 1.663976,2.97655305 1.607132,-2.97655305 z",
                'transform': 'translate(-10.829631,2.1938262)'
            },
            modecomponents: {
                "HARAPPAWORLD": [
                    "S-Indian",
                    "Baloch",
                    "Caucasian",
                    "NE-Euro",
                    "SE-Asian",
                    "Siberian",
                    "NE-Asian",
                    "Papuan",
                    "American",
                    "Beringian",
                    "Mediterranean",
                    "SW-Asian",
                    "San",
                    "E-African",
                    "Pygmy",
                    "W-African"
                ],
                "EUROGENESK13": [
                    "North_Atlantic",
                    "Baltic",
                    "West_Med",
                    "West_Asian",
                    "East_Med",
                    "Red_Sea",
                    "South_Asian",
                    "East_Asian",
                    "Siberian",
                    "Amerindian",
                    "Oceanian",
                    "Northeast_African",
                    "Sub-Saharan"
                ],
                "DODECADK12B": [
                    "Gedrosia",
                    "Siberian",
                    "Northwest African",
                    "Southeast Asian",
                    "Atlantic Med",
                    "North European",
                    "South Asian",
                    "East African",
                    "Southwest Asian",
                    "East Asian",
                    "Caucasus",
                    "Sub Saharan"
                ],
                "GLOBE13": [
                    "Siberian",
                    "Amerindian",
                    "West African",
                    "Palaeo African",
                    "Southwest Asian",
                    "East Asian",
                    "Mediterranean",
                    "Australasian",
                    "Artic",
                    "West Asian",
                    "North European",
                    "South Asian",
                    "East African"
                ],
                "K36": [
                    "Amerindian",
                    "Arabian",
                    "Armenian",
                    "Basque",
                    "Central African",
                    "Central Euro",
                    "East African",
                    "East Asian",
                    "East Balkan",
                    "East Central Asian",
                    "East Central Euro",
                    "East Med",
                    "Eastern Euro",
                    "Fennoscandian",
                    "French",
                    "Iberian",
                    "Indo-Chinese",
                    "Italian",
                    "Malayan",
                    "Near Eastern",
                    "North African",
                    "North Atlantic",
                    "North Caucasian",
                    "North Sea",
                    "Northeast African",
                    "Oceanian",
                    "Omotic",
                    "Pygmy",
                    "Siberian",
                    "South Asian",
                    "South Central Asian",
                    "South Chinese",
                    "Volga-Ural",
                    "West African",
                    "West Caucasian",
                    "West Med"
                ]
            },
            colorindex: 0,
            editing: false,
            theme: false,
            redraw: false,
            scene: {},
            plotId: 0,
            currentShare: false,
            lastShared: false,
            editable: false,
            data: [],
            annotations: Date.now(),
            shareUrl: {},
            component: 'pca',
            smallScreen: window.innerWidth < 620 ? true : false,
            maxGroupExceeded: "",
            maxExceededMessage: "",
            public: 0,
            saving: false,
            groups: [],
            g25Data: '',
            publicSamples: [],
            publicGroups: [],
            publicRawSamples: [],
            publicRawGroups: [],
            groupsCline: [],
            groupsAge: [],
            metadata: [],
            treedata: [],
        }
    },
    async beforeCreate() {},
    created() {
        if (typeof(pcaworker) != 'undefined') {
            pcaworker.status()
        }
        this.debouncedSearchSamples = debounce(this.searchSamples, 250)
        this.debouncedSearchGroups = debounce(this.searchGroups, 200)
        this.debouncedSearchGroupsPlus = debounce(this.searchGroupsPlus, 250)
        this.filteredOptions = []
        this.filteredGroupOptions = []
        this.filteredGroupPlusOptions = []
        window.__GenoStart = Date.now()
        let w = this;
        this.init()
        console.log(`Created: ${Date.now() - window.__GenoStart} ms`)
        this.showshare = false
        this.saveReady2 = false
        this.annotations = 0;
        this.mode = '2d'
        this.$eventBus.$on('authState', this.authState)
        //this.resetMode()

        this.$eventBus.$on('appEvents', this.appEvents)
        this.surface = false;
        //this.switches = this.$store.getters.get('plotSwitches');
        this.setSurface()
    },
    beforeDestroy() {
        if (typeof(pcaworker) != 'undefined') {
            console.log('Terminating PCA worker')
            pcaworker.terminate()
        }
        this.$eventBus.$off('appEvents', this.appEvents)
        this.shareready = false;
    },
    beforeMount() {
        this.showshare = false;
        this.explaining = false;
        this.$toasted.clear()
        this.plotlyMounted = Date.now()
    },
    mounted: async function() {
        let w = this;
        console.log('switches', w.switches)
        try {
            let switches = w.switches
            switches.sort = true;
            this.$store.commit('change', {
                switches: switches
            })
        } catch (err) {
            console.log(err);
        }
        console.log(`PCA Mount started ${Date.now() - routeStart} ms`)
        requestIdleCallback(async () => {
            this.$store.commit('change', {
                pcaLoaded: true
            })
            this.pcacustomsamples = [];
            this.pcaRerun = false;
            this.annotationCLicked = false
            this.markerArea = false
            this.lastMarkerState = false;
            this.spinner = false;
            this.exporting = false;
            this.colorindex = 0;
            this.pcaClass = "default"
            this.titleText = false;
            this.activePath = false;
            this.activeName = false;
            this.activeContent = false;
            this.activeTitle = false;
            this.editing = false;
            this.firstrun = true;
            let theme = localStorage.getItem('genoTheme');
            this.theme = theme && theme == 'dark' ? true : false;
            this.spinner = false;
            //if (this.$store.getters.get('plotGroupSamples') && this.customGroupModel.length === 0) this.$refs.tree.setCheckedNodes(this.$store.getters.get('plotGroupSamples'))
            var version = localStorage.getItem('cacheVer') ? localStorage.getItem('cacheVer') : 1
            var queryParam = version === 0 ? '' : '?v=0.' + version;
            var stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
            stage = '';
            let currentDT = Math.floor(Date.now() / 1000)
            let cache = localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                groups: {
                    g25: currentDT
                },
                samples: currentDT,
                tos: 0,
                calcVersion: currentDT
            }
            var UTF8to16 = function(convertMe) {
                var out = "";
                for (var i = 0; i < convertMe.length; i += 2) {
                    var charCode = convertMe.charCodeAt(i) * 256;
                    charCode += convertMe.charCodeAt(i + 1);
                    out += String.fromCharCode(charCode);
                }
                return out;
            }
            w.treedata = window.g25cache && window.g25cache.getTreeDataCache ? window.g25cache.getTreeDataCache : await this.$dbCache.getTreeDataCache(cache, 'pca', stage)
            let rerun = localStorage.getItem('pcaRerun')
            if (rerun) {
                rerun = decodeURI(rerun).replace('%2F', '/')
                this.pcaRerun = `${rerun.split('|')[0]}-shares.genoplot.com/${rerun.split('|')[1].replace(/:/,'/')}/samples`
                localStorage.removeItem('pcaRerun')
                let sharekey = rerun
                this.getShare(sharekey);
            }
            let autopca = this.$store.getters.get('autopca')
            let runAutoPCA = async function() {
                if (autopca != true) w.existingTitle = autopca + ` (${w.mode.toUpperCase()} PCA)`
                let switches = {
                    ...w.switches
                }
                let name = w.user.username + ':plot:switches'
                w.runPCA = true;
                w.pcacustomsamples = [];
                w.interestedModel = [];
                switches.editPCA = true
                switches.removeOutliers = false;
                w.plotMode = false;
                switches.averaged = false;
                try {
                    let components = 30
                    if (w.customGroupModel.length == 1 && w.customGroupModel[0].components) {
                        if (typeof(w.customGroupModel[0].components) == 'string') {
                            components = JSON.parse(w.customGroupModel[0].components).length
                        } else {
                            components = w.customGroupModel[0].components.length
                        }
                    } else {
                        components = w.customGroupModel.length
                    }
                    switches.all = components > 25 ? false : true
                    let rerun = w.customGroupModel[0] && w.customGroupModel[0].pca ? w.customGroupModel[0].pca : false
                    if (rerun) {
                        rerun = rerun.split('/')
                        if (rerun.length == 7 && rerun[4] == 'pca') {
                            rerun = `${rerun[4]}|${rerun[5].replace(/#/,'')}:${rerun[6].slice(0,-1)}`
                            //rerun = "pca|Genoplot:17f09595e3b"
                            w.pcaRerun = `${rerun.split('|')[0]}-shares.genoplot.com/${rerun.split('|')[1].replace(/:/,'/')}/samples`
                            w.runPCA = false;
                            switches.all = false;
                            let sharekey = rerun
                            let params = await w.getShare(sharekey, true);
                            w.layout = params.layout;
                        }
                    }
                    var switchesObj = {
                        plotSwitches: switches
                    }
                    w.switches = switches
                    w.$store.commit('change', w.switches)
                    localStorage.setItem(name, JSON.stringify(switches));
                    console.log('components', components, rerun);
                    w.loadPCA()
                } catch (err) {
                    console.log(err)
                }
            }
            if (autopca) {
                runAutoPCA()
            }
            this.$store.commit('change', {
                autopca: false
            })
            requestIdleCallback(async () => {
                w.publicGroups = window.g25cache && window.g25cache.getG25Groups ? window.g25cache.getG25Groups : await this.$dbCache.getG25Groups(cache, 'pca', stage)
                w.publicSamples = window.g25cache && window.g25cache.getSampleGroups ? window.g25cache.getSampleGroups : await this.$dbCache.getSampleGroups(cache, 'pca', stage)
                let customGroups = []
                w.publicSamples.forEach(x => {
                    let indexes = []
                    x.samples.map((sample, i) => {
                        x.originalGroup = sample.group
                        if (sample.alias) {
                            x.group = sample.alias
                            x.alias = sample.alias
                        }
                        if (sample.customgroup) {
                            indexes.push(i)
                            let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customGroups[customIndex].samples.push(sample)
                            } else {
                                customGroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    type: sample.mode,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    if (indexes.length > 0) {
                        x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                    }
                })
                this.customGroups = customGroups
                w.publicRawGroups = window.g25cache && window.g25cache.getRawGroupsCache ? window.g25cache.getRawGroupsCache : await this.$dbCache.getRawGroupsCache(cache, 'pca', stage)
                w.publicRawSamples = window.g25cache && window.g25cache.getRawGroupedSamplesCache ? window.g25cache.getRawGroupedSamplesCache : await this.$dbCache.getRawGroupedSamplesCache(cache, 'pca', stage)
                this.toggleTheme()
                if (this.customGroupModel.length > 0) this.activeTab = "custom"
                if (this.user && this.user.username) {
                    var name = this.user.username + ':plot:switches'
                    var switches = localStorage.getItem(name);
                    if (switches) {
                        switches = JSON.parse(switches);
                        this.$store.commit('change', switches)
                    }
                }
                //localStorage.setItem('pcaRerun', 'pca|Genoplot:1797cd305a3')
                requestIdleCallback(async () => {
                    //this.getLocalStorage();
                })
                console.log(`PCA Mount finished ${Date.now() - routeStart} ms`)
                this.pcamounted = true;
            })
        })
    },
    computed: {
        ...mapState({
            onLine: 'onLine',
            user: 'user',
            alias: 'alias',
            env: 'env',
            isAdmin: 'isAdmin',
            usergroups: 'usergroups',
            slider: 'slider',
            alias: 'alias',
            subs: 'subscription',
            g25switches: 'switches',
            screenWidth: 'screenWidth'
        }),
        getGroupOrOptions() {
            const groups = [];
            const groupOptions = [];
            this.sampleModel.forEach((option) => {
                const group = option.customgroup ? this.getGroup("customgroup", option.customgroup) : this.getGroup("group", option.group);
                if (group && this.isAllOptionsSelectedInGroup(group)) {
                    if (!groups.includes(group.group)) {
                        groups.push(group.group);
                        let label = group.group + ' (Group)'
                        groupOptions.push({
                            label: label,
                            option: group,
                            group: true
                        });
                    }
                } else {
                    groupOptions.push({
                        label: this.customSample(option),
                        option,
                        group: false
                    });
                }
            });
            return groupOptions;
        },
        groupedSamples: {
            get: function() {
                return this.$store.getters.get(`groupedSamples`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    groupedSamples: value
                })
            },
        },
        screenshot: {
            get: function() {
                return this.$store.getters.get(`screenshot`) ? true : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    screenshot: value
                })
            },
        },
        filteredOptions: {
            get() {
                if (this.filteredSamples.length == 1 && this.filteredSamples[0].empty) {
                    return []
                } else if (this.filteredSamples.length == 0) {
                    return this.sampleOptions.slice(0, 300)
                }
                return this.filteredSamples.slice(0, 300)
            },
            set(value) {
                this.filteredSamples = value;
            }
        },
        filteredGroupOptions: {
            get() {
                if (this.filteredGroupSamples.length == 1 && this.filteredGroupSamples[0].empty) {
                    return []
                } else if (this.filteredGroupSamples.length == 0) {
                    return this.groupOptions.slice(0, 300)
                }
                return this.filteredGroupSamples.slice(0, 300)
            },
            set(value) {
                this.filteredGroupSamples = value;
            }
        },
        filteredGroupPlusOptions: {
            get() {
                if (this.filteredGroupPlusSamples.length == 1 && this.filteredGroupPlusSamples[0].empty) {
                    return []
                } else if (this.filteredGroupPlusSamples.length == 0) {
                    return this.groupsPlusOptions.slice(0, 300)
                }
                return this.filteredGroupPlusSamples.slice(0, 300);
            },
            set(value) {
                this.filteredGroupPlusSamples = value;
            }
        },
        src: {
            get: function() {
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                if (src.includes('/?share=')) {
                    src = src.replace(/\#/, `\&ts=${Date.now()}#`)
                } else {
                    src = src.replace(/\/#/, `?ts=${Date.now()}/#`)
                }
                let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                let genoTheme = this.getInitialColorMode(value)
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1 && src) src = src.replace(/\#.*/, '') + (genoTheme == 'dark' ? '#2' : '#1')
                return src ? src : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    sharedurl: value
                })
            },
        },
        calculator: function() {
            let klass = this.customGroupModel[0] && this.customGroupModel[0].calculator ? true : false
            return klass
        },
        userSamples: {
            set: function(value) {
                console.log('set', value)
                this.$store.commit('change', {
                    'userSamples': value
                })
            },
            get: function(value) {
                let samples = this.$store.getters.get('userSamples') ? JSON.parse(JSON.stringify(this.$store.getters.get('userSamples'))) : []
                samples = [{
                    group: this.alias ? this.alias : this.user.username,
                    originalGroup: this.user.username,
                    samples: samples
                }]
                samples[0].samples = samples[0].samples.filter(x => x.type == this.modetype)
                return samples
            }
        },
        proxyUser: {
            get: function() {
                if (this.isAdmin && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.priorProxy) {
                    this.priorProxy = this.$store.getters.get('proxyUser')
                    this.init()
                }
                return 'proxy'
            },
            set: function(value) {
                this.priorProxy = this.$store.getters.get('proxyUser')
                this.$store.commit('change', {
                    proxyUser: value
                })
            }
        },
        markup: {
            set: function(value) {
                this.$store.commit('change', {
                    markup: value
                })
            },
            get: function() {
                return this.$store.getters.get('markup')
            },
        },
        editedImageUrl: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl')
            },
        },
        editedImageUrl2: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl2: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl2')
            },
        },
        showshare: {
            set: function(value) {
                this.$store.commit('change', {
                    showshare: value
                })
            },
            get: function() {
                let showshare = this.$store.getters.get('showshare')
                this.saveReady2 = false;
                this.frameDisplay = 'none'
                this.shareTitle = false
                let user = this.user && this.user.username ? this.user.username : ''
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1) this.shareTitle = this.$store.getters.get(`sharedurl`).split('||')[1]
                if (showshare) {
                    setTimeout(() => {
                        let evt = 'rightpanel';
                        this.$root.$emit(evt, 'close');
                    }, 300)
                }
                return this.$store.getters.get('showshare')
            },
        },
        editingImage: {
            set: function(value) {
                this.$store.commit('change', {
                    editingImage: value
                })
            },
            get: function() {
                return this.$store.getters.get('editingImage')
            },
        },
        parentClass: function() {
            let klass = (this.exporting ? 'hideToolbar ' : '') + (this.switches.editPCA ? 'editable' : '') + (this.saveReady ? ' socialready' : '')
            return klass
        },
        advanced: function() {
            return this.usergroups.indexOf('advanced') >= 0 ? true : false
        },
        modes: function() {
            let defaultmodes = [{
                    label: 'Global 25 (G25)',
                    value: 'G25'
                },
                {
                    label: 'HarappaWorld',
                    value: 'HARAPPAWORLD',
                    components: 16
                },
                {
                    label: 'Eurogenes K13',
                    value: 'EUROGENESK13',
                    components: 13
                },
                {
                    label: 'Dodecad World K12',
                    value: 'DODECADK12B',
                    components: 12
                },
                {
                    label: 'Dodecad Globe K13',
                    value: 'GLOBE13',
                    components: 13
                },
                {
                    label: 'Eurogenes Global K36',
                    value: 'K36',
                    components: 36
                }
            ]
            let enhanced = [
                //{ label: 'Geno25 (v1)', value: 'GENO25V1', components: 25 },
                {
                    label: 'Geno25 (v2)',
                    value: 'GENO25V2',
                    components: 25
                },
                //{ label: 'Geno25 (v3)', value: 'GENO25V3', components: 25 },
            ]
            if (this.isAdmin || this.advanced) {
                return enhanced.concat(defaultmodes)
            } else {
                return defaultmodes
            }
        },
        pcaRerun: {
            set: function(value) {
                this.$store.commit('change', {
                    pcaRerun: value
                })
            },
            get: function() {
                return this.$store.getters.get('pcaRerun')
            },
        },
        pcacustomsamples: {
            set: function(value) {
                this.$store.commit('change', {
                    pcacustomsamples: value
                })
            },
            get: function() {
                return this.$store.getters.get('pcacustomsamples')
            },
        },
        highlightSamples() {
            let w = this;
            let search = function() {
                if (w.searchterm && w.searchterm.length > 2) {
                    let matched = w.sampleids.filter(x => x.toLowerCase().indexOf(w.searchterm.toLowerCase()) >= 0)
                    return matched.length
                }
                return 0
            }
            let debounce = function(fn, threshold) {
                console.log(fn, threshold);
                var timeout;
                return function debounced() {
                    if (timeout) {
                        clearTimeout(timeout);
                    }

                    function delayed() {
                        fn();
                        timeout = null;
                    }
                    //timeout = setTimeout(delayed, threshold || 100);
                    timeout = setTimeout(5000);
                }
            }
            return debounce(search(), 2000)
        },
        sampleids() {
            if (this.data && this.data.length > 0) {
                let ids = []
                let data = this.data
                let z = this.data[0].z ? true : false
                data.map((group, i) => {
                    group.id.map((id, index) => {
                        ids.push({
                            id: id,
                            curve: i,
                            point: index,
                            x: -1 * data[i].x[index],
                            y: -1 * data[i].y[index],
                            z: z ? data[i].z[index] : undefined
                        })
                    })
                })
                return ids
            } else {
                return []
            }
        },
        switches: {
            get() {
                return this.$store.getters.get('plotSwitches')
            },
            set(value) {
                this.$store.commit('change', {
                    plotSwitches: value
                })
            }
        },
        searchterm: {
            get() {
                return this.$store.getters.get('searchPCA')
            },
            set(value) {
                this.$store.commit('change', {
                    searchPCA: value
                })
            }
        },
        modebarButtons2D() {
            let w = this;
            let defaulticons = ["toImage", "zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "resetScale2d"]
            let upload = {
                name: 'Copy Screenshot',
                icon: w.uploadIcon,
                click: async function(gd) {
                    w.spinner = true;
                    setTimeout(async () => {
                        let image = document.getElementById('pcaDiv')
                        let width = image.clientWidth
                        let height = image.clientHeight
                        let svg = await PlotlyInstance.toImage(gd, {
                            format: 'svg',
                            width: width,
                            height: height
                        })
                        w.uploadImage(svg, 'svg')
                    }, 0)
                }
            }
            let flipx = w.xflipped
            let icon = flipx ? w.xminusIcon : w.xplusIcon
            let click = function() {
                w.xflipped = w.xflipped ? false : true
                w.loadPCA(true)
            }
            let name = flipx ? 'Unflip X Axis' : 'Flip X Axis'
            let buttonx = {
                name: name,
                icon: icon,
                click: click
            }
            let flipy = this.yflipped
            icon = flipy ? this.yminusIcon : this.yplusIcon
            click = function() {
                w.yflipped = w.yflipped ? false : true
                w.loadPCA(true)
            }
            name = flipy ? 'Unflip Y Axis' : 'Flip Y Axis'
            let buttony = {
                name: name,
                icon: icon,
                click: click
            }
            let modebar = [
                [buttonx, buttony, upload].concat(defaulticons)
            ]
            return modebar
        },
        modebarButtons3D() {
            let w = this;
            let defaulticons = ["toImage", "zoom3d", "pan3d", "resetCameraDefault3d", "resetCameraLastSave3d", "hoverClosest3d", "orbitRotation", "tableRotation"]
            let upload = {
                name: 'Copy Screenshot',
                icon: w.uploadIcon,
                click: async function(gd) {
                    w.spinner = true;
                    setTimeout(async () => {
                        let image = document.getElementById('pcaDiv')
                        let width = image.clientWidth
                        let height = image.clientHeight
                        let svg = await PlotlyInstance.toImage(gd, {
                            format: 'svg',
                            width: width,
                            height: height
                        })
                        w.uploadImage(svg, 'svg')
                    }, 0)
                }
            }
            let flipx = w.xflipped
            let icon = flipx ? w.xminusIcon : w.xplusIcon
            let click = function() {
                w.xflipped = w.xflipped ? false : true
                w.loadPCA(true)
            }
            let name = flipx ? 'Unflip X Axis' : 'Flip X Axis'
            let buttonx = {
                name: name,
                icon: icon,
                click: click
            }
            let flipy = this.yflipped
            icon = flipy ? this.yminusIcon : this.yplusIcon
            click = function() {
                w.yflipped = w.yflipped ? false : true
                w.loadPCA(true)
            }
            name = flipy ? 'Unflip Y Axis' : 'Flip Y Axis'
            let buttony = {
                name: name,
                icon: icon,
                click: click
            }
            let modebar = [
                [buttonx, buttony, upload].concat(defaulticons)
            ]
            return modebar
        },
        xflipped: {
            set: function(value) {
                this.$store.commit('change', {
                    xflipped: value
                })
            },
            get: function(value) {
                let flipped = this.$store.getters.get('xflipped')
                return flipped
                this.data = this.data.map(x => x.x.map(point => -1 * point))
            }
        },
        yflipped: {
            set: function(value) {
                this.$store.commit('change', {
                    yflipped: value
                })
            },
            get: function(value) {
                let flipped = this.$store.getters.get('yflipped')
                return flipped
                this.data = this.data.map(x => x.y.map(point => -1 * point))
            }
        },
        modetype: {
            set: function(value) {
                this.$store.commit('change', {
                    monteMode: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('monteMode') ? this.$store.getters.get('monteMode') : 'G25'
            }
        },
        subType() {
            return this.subs && this.subs.subType && this.subs.subType.indexOf('gold') >= 0 ? 2 : this.subs && this.subs.subType && this.subs.subType.indexOf('silver') >= 0 ? 1 : 0
        },
        autoExpandTree: function() {
            return this.groupModel && this.groupModel[0] ? [this.groupModel[0].id.split(':')[0]] : ['1']
        },
        plotlyTheme: function() {
            return this.theme ? 'dark' : 'light'
        },
        spinner: {
            get: function() {
                return this.$store.getters.get('spinner')
            },
            set: function(value) {
                this.$store.commit('change', {
                    spinner: value
                })
            }
        },
        firstrun: {
            get: function() {
                return this.$store.getters.get('pcafirstrun')
            },
            set: function(value) {
                this.$store.commit('change', {
                    pcafirstrun: value
                })
            }
        },
        progress: {
            get: function() {
                return this.$store.getters.get('progress')
            },
            set: function(value) {
                this.$store.commit('change', {
                    progress: value
                })
            }
        },
        sampleModel: {
            get: function() {
                return this.$store.getters.get('plotUserSamples')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotUserSamples: value
                })
            }
        },
        style: {
            get: function() {
                return this.$store.getters.get('plotStyle')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotStyle: value
                })
            }
        },
        surface: {
            get: function() {
                return this.$store.getters.get('plotSurface')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotSurface: value
                })
            }
        },
        plotMode: {
            get: function() {
                return this.$store.getters.get('plotMode')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotMode: value
                })
            }
        },
        mode: {
            get: function() {
                return this.$store.getters.get('plotMode') ? '3d' : '2d'
            },
            set: function(value) {
                let mode = value === '3d' ? true : false
                this.$store.commit('change', {
                    plotMode: mode
                })
            }
        },
        mesh: {
            get: function() {
                return this.$store.getters.get('plotMesh')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotMesh: value
                })
            }
        },
        groupModel: {
            get: function() {
                return this.$store.getters.get('plotGroupSamples')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotGroupSamples: value
                })
            }
        },
        customGroupModel: {
            get: function() {
                return this.$store.getters.get('plotCustomGroups')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotCustomGroups: value
                })
            }
        },
        interestedModel: {
            get: function() {
                return this.$store.getters.get('plotInterestedSamples')
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotInterestedSamples: value
                })
            }
        },
        sampleJSON: function() {
            if (this.userSamples[0]) {
                if (this.mode == 'G25') {
                    let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.originalGroup = this.userSamples[0].group
                    userSamples.group = this.alias ? this.alias : this.userSamples[0].group
                    console.log('mysamples', userSamples);
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    originalgroup: sample.group,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                } else {
                    let publicSamples = this.publicRawSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.samples.filter(x => x.sample.indexOf('Average') < 0 && x.sample.indexOf('Median') < 0 && !x.customgroup)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                }
            } else {
                if (this.mode == 'G25') {
                    return this.publicSamples
                } else {
                    return this.publicRawSamples
                }
            }
        },
        sampleJSON2: function() {
            if (this.userSamples[0]) {
                if (this.modetype == 'G25') {
                    let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                } else {
                    let publicSamples = this.publicRawSamples.filter(x => x.type == this.modetype && x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.sample.filter(x => x.type == this.modetype)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                }
            } else {
                if (this.modetype == 'G25') {
                    return this.publicSamples
                } else {
                    return this.publicRawSamples
                }
            }
        },
        sampleOptions: function() {
            let samples = this.userSamples[0] && this.userSamples[0].samples ? this.userSamples : [{
                group: this.user.username,
                samples: []
            }]
            if (this.modetype == 'G25') {
                let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                return samples.concat(publicSamples)
            } else {
                let publicSamples = this.publicRawSamples.filter(x => x.group !== this.userSamples[0].group)
                return samples.concat(publicSamples)
            }
        },
        groupsPlusOptions: function() {
            if (this.user) {
                if (this.modetype === 'G25') {
                    if (this.userSamples[0]) {
                        var index = this.publicSamples.findIndex(pgroup => pgroup.group === this.userSamples[0].group)
                        if (index >= 0) this.publicSamples.splice(index, 1)
                        return this.sampleOptions;
                    } else {
                        return this.sampleOptions;
                    }
                } else {
                    if (this.userSamples[0]) {
                        return this.sampleOptions.concat(this.publicRawSamples);
                    } else {
                        return this.publicRawSamples
                    }

                }
            }
        },
        groupOptions: function() {
            let customgroups = this.customGroups.concat(this.customUserGroups)
            if (this.calculator) {
                return []
            } else {
                return this.groupJSON.concat(customgroups);
            }
        },
        showNonRawUploadIcons: function() {
            return true;
        },
        groupJSON: function() {
            if (this.userSamples && this.userSamples.length > 0) {
                let customgroups = []
                let userSamples = JSON.parse(JSON.stringify(this.userSamples))
                userSamples[0].samples.filter(x => x.type === this.modetype).map(sample => {
                    if (sample.customgroup) {
                        let customIndex = customgroups.findIndex(x => x.label == sample.customgroup + ' [' + sample.group + ']');
                        if (customIndex >= 0) {
                            customgroups[customIndex].samples = customgroups[customIndex].samples + 1
                        } else {
                            customgroups.push({
                                label: sample.customgroup + ' [' + sample.group + ']',
                                samples: 1,
                                customgroup: sample.customgroup,
                                origin: sample.origin,
                                type: sample.type
                            })
                        }
                    }
                })
                if (this.modetype === 'G25') {
                    return this.publicGroups.concat(customgroups)
                } else {
                    return this.publicRawGroups.concat(customgroups)
                }
            } else {
                if (this.mode === 'G25') {
                    return this.publicGroups
                } else {
                    return this.publicRawGroups
                }
            }
        },
    },
    methods: {
        selectElementContents: function(el) {
            var range = document.createRange();
            range.selectNodeContents(el);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        },
        getGroup(key, value) {
            return this.sampleOptions.find((option) =>
                option.samples.some((sample) => sample[key] === value)
            );
        },
        isAllOptionsSelectedInGroup(group) {
            return group.samples.every((sample) => {
                return this.sampleModel.some((val) => val.sample === sample.sample)
            });
        },
        removeGroupOrOption(data, removeOptionFunction) {
            if (data.samples) {
                this.sampleModel = this.sampleModel.filter(x => x.group !== data.group)
            } else {
                removeOptionFunction(data);
            }
        },
        searchGroups: function(input) {
            let search = input.toLowerCase();
            let options = this.groupOptions;
            if (!input || input.length < 3) {
                this.filteredGroupSamples = options.slice(0, 300)
                return;
            }
            const {
                filteredData,
                filterString
            } = filterData(search, options, 'refs');
            this.filteredGroupSamples = filteredData && filteredData.length ? filteredData.slice(0, 300) : [{
                empty: true
            }]
            return;
        },
        searchGroupsPlus: function(input) {
            let search = input.toLowerCase();
            let options = this.groupsPlusOptions;
            if (!input || input.length < 3) {
                this.filteredGroupPlusSamples = options.slice(0, 300)
                return;
            }
            const {
                filteredData,
                filterString
            } = filterData(search, options, 'refs', 'samples');
            //console.log('Filter String:', filterString);
            this.filteredGroupPlusSamples = filteredData && filteredData.length ? filteredData.slice(0, 300) : [{
                empty: true
            }]
            return
        },
        searchSamples: function(input) {
            let search = input.toLowerCase();
            let options = this.sampleOptions
            if (!input || input.length < 3) {
                this.filteredOptions = options.slice(0, 300)
                return;
            }
            const {
                filteredData,
                filterString
            } = filterData(search, options, 'refs', 'samples');
            //console.log('Filter String:', filterString);
            this.filteredOptions = filteredData && filteredData.length ? filteredData.slice(0, 300) : [{
                empty: true
            }]
            return
        },
        authState: function(info) {
            if (info === 'signedIn') {
                this.init
            }
        },
        showArticle(evt) {
            this.$genericevent.showArticle(evt);
        },
        closeDrawer: function() {
            this.showshare = false
            this.saveReady2 = false
            this.frameDisplay = 'none'
            if (!this.saveReady) {
                setTimeout(() => {
                    this.$root.$emit('rightpanel', 'open');
                }, 300)
            }
        },
        onLoad: function(evt) {
            console.log('loaded', evt)
            if (evt.target.src != '') {
                this.frameDisplay = 'block'
                this.saveReady2 = true
            }
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        },
        selectSearchText(ref) {
            this.$refs[ref].$refs.search.focus()
            this.$refs[ref].$refs.search.select()
        },
        clearSearch() {
            this.searchterm = undefined;
        },
        createImage: async function(svg, type) {
            var filename = 'pca';
            var w = this;
            if (type && type === 'svg') {
                var img = new Image();
                img.src = svg
                window.saveAs(svg, `${filename}.svg`);
            } else {
                var style = el === 'table' ? {
                    marginLeft: 0,
                    marginTop: '-50px',
                    padding: 0
                } : el === 'barchart' ? {
                    'margin-left': 'unset',
                    'width': '100%',
                    marginTop: '-10px',
                    padding: 'unset'
                } : {
                    marginLeft: 0,
                    padding: 0
                }
                domtoimage.toBlob(node, {
                        bgcolor: this.theme ? 'transparent' : 'white',
                        style: style
                    })
                    .then(function(blob) {
                        var img = new Image();
                        img.src = blob
                        window.saveAs(blob, `${filename}.png`);
                    })
            }

        },
        customCalcLabel(calc) {
            return (`${unescape(calc.calculator)} by ${calc.user} - ${calc.description}`)
        },
        uploadImage: async function(svg, type) {
            //type = 'svg';
            let w = this;
            type = w.screenshot ? 'svg' : 'png'
            console.log('started')
            w.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                delete w.markerArea
                w.editedImageUrl = undefined
                w.editedImageUrl2 = undefined
                w.exporting = true;
                let element = 'pca'
                try {
                    let contentType = type == 'png' ? "image/png" : "image/svg+xml"
                    let fileType = 'image'
                    let name = w.alias ? w.alias : w.user.username;
                    let path = `${name}/${element}-${Date.now().toString(16)}`
                    let sigparams = {
                        filePath: path,
                        fileType: fileType,
                        contentType: contentType
                    }
                    let prefix = 'https://shared.genoplot.com/file/genofiles'
                    let svgUrl = svg;
                    svg = svg.replace(/data\:image\/svg\+xml\,/, '')
                    svg = decodeURIComponent(svg)
                    let style = ''
                    style = "<style>* { pointer-events: none;}</style>"
                    w.markup = false;
                    let image = document.getElementById('editImage')
                    w.debounceSearch()
                    image.onload = () => {
                        if (!w.markerArea) {
                            console.log('Loading markers')
                            let markerArea = new markerjs2.MarkerArea(image);
                            markerArea.addCloseEventListener(data => {
                                delete w.markerArea
                                if (!w.markup) {
                                    //w.spinner = false;
                                    w.exporting = false;
                                } else {}
                            })
                            markerArea.addRenderEventListener(async (dataUrl, state) => {
                                w.editedImageUrl2 = dataUrl;
                                let replaceStr = svg.substring(svg.indexOf("<svg"), svg.indexOf('style=""'))
                                let newSVG = document.getElementById('markerSVG').outerHTML
                                console.log('markup as pushed')
                                if (newSVG) {
                                    let markup = newSVG.replace(/<svg xml.*?view/, replaceStr + ' view')
                                    svg = svg.replace(/\<\/svg\>/, `${markup}</svg>`)
                                    svg = svg.replace(/style=""/, `style="padding:10px;` + (w.theme ? `background: #181818"` : `background: #f2f2f2;"`))
                                }
                                w.markerState = state;
                                w.spinner = true;
                                await w.putImage(svg, prefix, path, sigparams, element, type)
                                w.editedImageUrl = undefined
                                w.editedImageUrl2 = undefined
                            });
                            w.markerArea = markerArea
                        }
                        let theme = (w.slider.colors.value - 1) % 5
                        let colors = w.chartColors[theme];
                       w.markerArea.settings.defaultColorSet = w.theme ? colors.concat(['transparent', '#ffffff', '#181818', '#f2f2f2' ]) : colors.concat(['transparent', '#e31a1c', '#181818', '#f2f2f2'])
                        w.markerArea.settings.displayMode = 'popup';
                        w.markerArea.renderAtNaturalSize = false;
                        w.markerArea.settings.defaultOpacitySteps = [0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1]
                        w.markerArea.settings.defaultColor = w.theme ? '#ffffff' : '#e31a1c'
                        w.markerArea.settings.defaultFontFamilies = ["Segoe UI", "Helvetica", "Arial", "sans-serif"]
                        w.markerArea.settings.defaultFontFamily = "Segoe UI"
                        w.markerArea.settings.defaultStrokeWidth = 2;
                        w.markerArea.settings.savedlink = false;
                        w.markerArea.renderImageType = "image/svg+xml;charset=utf-8"
                        w.markerArea.renderMarkersOnly = true;
                        w.markerArea.availableMarkerTypes = ["ArrowMarker", 'LineMarker', 'MeasurementMarker', "FreehandMarker", "FrameMarker", "HighlightMarker", EllipseMarker2, HighlightEllipseMarker, 'CalloutMarker', "TextMarker"];
                        if (w.markerState && w.markerState.savedlink) {
                            w.markerArea.settings.savedlink = w.markerState.savedlink
                        }
                        w.markerArea.show();
                        w.spinner = false;
                        if (w.markerState) {
                            w.markerArea.restoreState(w.markerState);
                        }
                    }
                    w.editedImageUrl = svgUrl;
                } catch (err) {
                    w.spinner = false
                    w.exporting = false;
                    console.log(err);
                }
            }, 0)
        },
        showShared: async function(url, element) {
            let w = this;
            let buttons = [{
                title: "Copy URL",
                handler: (i, event) => {
                    copy(url)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: "Copy URL (BBCode)",
                handler: (i, event) => {
                    let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                    copy(bburl)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: 'Close',
                default: true
            }]
            w.$modal.show('dialog', {
                title: 'Link to sharable image',
                text: `You can now share an image of this ${element} from this <a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                buttons: buttons,
                clickToClose: false,
                beforeClosed: function(event) {
                    console.log('closing', event)
                }
            })
        },
        putImage: async function(svg, prefix, path, sigparams, element, type) {
            let w = this;
            w.spinner = true;
            if (type == 'png') {
                try {
                    async function convertSvgToPngBlob(svgString) {
                        const div = document.createElement('div');
                        div.style.position = 'absolute';
                        div.style.left = '-9999px';
                        div.innerHTML = svgString.trim();
                        document.body.appendChild(div);
                        try {
                            const blob = await domtoimage.toBlob(div.firstChild);
                            svg = await blob.arrayBuffer();
                            document.body.removeChild(div);
                        } catch (error) {
                            console.log('error', error);
                            document.body.removeChild(div);
                            w.spinner = false;
                        }
                    };
                    let blob = await convertSvgToPngBlob(svg);
                } catch (err) {
                    console.log('err', err)
                    document.body.removeChild(div);
                    w.spinner = false;
                }
            };
            let data = await w.$apollo.query({
                query: getFilebaseSignatureQuery,
                variables: {
                    params: JSON.stringify(sigparams)
                },
                fetchPolicy: 'network-only'
            })
            if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                let result = JSON.parse(data.data.getFilebaseSignature.result);
                let signedUrl = result.url;
                let options = {
                    headers: {
                        'Content-Type': sigparams.contentType,
                        'Content-Encoding': 'gzip',
                        'Cache-Control': 'max-age=86400'
                    }
                }
                const operation = w.$retry.operation({
                    retries: 3,
                    factor: 2,
                    minTimeout: 125,
                    maxTimeout: 1000,
                    randomize: false,
                });
                operation.attempt(async (currentAttempt) => {
                    try {
                        axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(svg)), options)
                            .then(function(result) {
                                w.spinner = false
                                w.exporting = false
                                w.currentShare = false;
                                console.log(`${prefix}/${path}`)
                                w.markerState.savedlink = `${prefix}/${path}`
                                w.lastMarkerState = w.markerState
                                delete w.markerArea
                                w.showShared(`${prefix}/${path}`, element)
                            })
                            .catch(function(err) {
                                if (operation.retry(err)) {
                                    return;
                                }
                                w.spinner = false
                                w.exporting = false;
                                console.log(err);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to upload Image",
                                        class: 'warning'
                                    }
                                })
                            });
                    } catch (e) {
                        if (operation.retry(e)) {
                            return;
                        }
                    }
                })
            } else {
                console.log(data);
                w.spinner = false
                w.exporting = false;
                w.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: "Error",
                        text: "unable to upload Image",
                        class: 'warning'
                    }
                })
            }
        },
        uploadImage2: async function(el, type) {
            let w = this;
            w.exporting = true;

            function showShare(url) {
                let buttons = [{
                    title: "Copy URL",
                    handler: (i, event) => {
                        copy(url)
                        document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                    }
                }, {
                    title: "Copy URL (BBCode)",
                    handler: (i, event) => {
                        let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                        copy(bburl)
                        document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                    }
                }, {
                    title: 'Close',
                    default: true
                }]
                w.$modal.show('dialog', {
                    title: 'Link to sharable image',
                    text: `You can now share an image of this PCA from this<br><a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                    buttons: buttons,
                    clickToClose: false,
                    beforeClosed: function(event) {
                        console.log('closing', event)
                    }
                })
            }
            try {
                let image = type;
                let contentType = "image/svg+xml"
                let fileType = 'image'
                let path = `${w.user.username}/${type}-${Date.now().toString(16)}`
                let sigparams = {
                    filePath: path,
                    fileType: fileType,
                    contentType: contentType
                }
                let data = await w.$apollo.query({
                    query: getFilebaseSignatureQuery,
                    variables: {
                        params: JSON.stringify(sigparams)
                    },
                    fetchPolicy: 'network-only'
                })
                if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                    let prefix = 'https://shared.genoplot.com/file/genofiles'
                    let result = JSON.parse(data.data.getFilebaseSignature.result);
                    let signedUrl = result.url;
                    let options = {
                        headers: {
                            'Content-Type': contentType,
                            'Content-Encoding': 'gzip',
                            'Cache-Control': 'max-age=86400'
                        }
                    }
                    let node = document.getElementById(el);
                    let style = el === 'pcaDiv' ? {
                        marginTop: '-100px',
                        marginBottom: '-30px',
                        marginLeft: 0,
                        padding: 0,
                        background: this.theme ? '#14191f' : '#f2f2f2'
                    } : el === 'barchart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset'
                    } : el === 'apex-heatmap' ? {
                        marginTop: '-25',
                        padding: 0
                    } : {
                        margin: 0,
                        padding: 0
                    }
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme && el === 'pcaDiv' ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(async function(blob) {
                            axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, ''))), options)
                                .then(function(result) {
                                    w.spinner = false
                                    w.exporting = false
                                    console.log(`${prefix}/${path}`)
                                    showShare(`${prefix}/${path}`)
                                    w.lastShared = w.plotId
                                })
                                .catch(function(err) {
                                    w.spinner = false
                                    w.exporting = false;
                                    console.log(err);
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'show',
                                        component: 'nav',
                                        params: {
                                            title: "Error",
                                            text: "unable to upload Image",
                                            class: 'warning'
                                        }
                                    })
                                });
                        }).catch(function(err) {
                            console.log(err);
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.exporting = false;

                        })
                } else {
                    console.log(data);
                    w.spinner = false
                    w.exporting = false;
                    w.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: "Error",
                            text: "unable to upload Image",
                            class: 'warning'
                        }
                    })
                }
            } catch (err) {
                w.spinner = false
                w.exporting = false;
                console.log(err);
            }
        },
        getShare: async function(key, norerun) {
            let w = this;
            w.$store.commit('change', {
                spinner: true
            })
            let variables = {
                key: key
            };
            try {
                let data = await w.$apollo.query({
                    query: getShareQuery,
                    variables: variables,
                    fetchPolicy: 'network-only'
                })
                w.$store.commit('change', {
                    spinner: false
                })
                if (data && data.data && data.data.getShare && data.data.getShare.params) {
                    let buffer = Buffer.from(data.data.getShare.params, 'base64')
                    let jsonStr = w.$zlib.unzipSync(buffer).toString()
                    let params = JSON.parse(jsonStr)
                    if (params.samples) {
                        w.pcacustomsamples = params.samples
                        w.pcaRerun = params.type + '-shares.genoplot.com/' + params.path + '/samples'
                    }
                    if (norerun) {
                        return params
                    } else {
                        w.rerun(params);
                    }
                } else {
                    return false
                }
            } catch (err) {
                console.log(err)
                w.$store.commit('change', {
                    spinner: false
                })
                this.collapsed = false;
                return false
            }
        },
        unhoverSamples() {
            if (this.hoverPoints && this.hoverPoints.length > 0) {
                PlotlyInstance.Fx.unhover('pcaDiv', this.hoverPoints)
                this.hoverPoints = undefined
            }
        },
        download: async function(event) {
            let w = this;
            console.log(event)
            let calculator = false;
            if (event === 'groups' || event === 'samples' || event === 'similarity') {
                let subId = this.$store.getters.get('user').username + ':' + Date.now();
                this.$store.commit('change', {
                    subId: subId
                })
                let name = event === 'groups' ? 'sources' : event === 'samples' ? 'targets' : 'categorized'
                name = name + '_datasheet.csv'
                let number = 0
                w.customGroupModel.map(x => {
                    number = number + (x.samples ? x.samples : 1)
                })
                let max = w.subType > 0 ? 500 : 250
                if (number > max) {
                    w.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: 'Maximum download size exceeded',
                            text: `You've selected ${number} samples<br/><b>The maximum number of samples that can be exported to a datasheet is ${max}</b><br/>If you need more than w number, please export in multiple batches`,
                            class: 'alert'
                        }
                    })
                } else {
                    this.$store.commit('change', {
                        spinner: true
                    })
                    let unscaled = this.mode !== 'G25' ? false : this.switches.scaled ? false : true;
                    let filtered = this.switches.removeOutliers ? true : false
                    let arr = event === 'groups' ? w.customGroupModel : w.sampleModel
                    let customsamples = false;
                    let submitArr = []
                    if (event === 'samples' || event === 'similarity') {
                        arr.forEach(sample => {
                            let vsample = w.modetype !== 'G25' && sample.mode ? sample.group + '|' + w.modetype : sample.v ? sample.group + '|' + sample.v : sample.group;
                            submitArr.push(vsample + ':' + sample.sample)
                        })
                    } else {
                        arr.forEach(group => {
                            if (group.label) {
                                group.label = group.label.replace(' ► ', ':')
                                let vgroup = group.v ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + group.v + ':' + group.label.split(':')[1] : group.label + '|' + group.v) : w.mode !== 'G25' ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + w.mode + ':' + group.label.split(':')[1] : group.label.split(':')[0] + '|' + w.mode) : group.label;
                                if (w.pcacustomsamples && w.pcacustomsamples.length > 0) customsamples = w.pcaRerun
                                submitArr.push(vgroup)
                            } else {
                                submitArr.push(group.group + ':' + group.sample)
                                quantity = quantity + 1;
                                if (w.pcacustomsamples && w.pcacustomsamples.length > 0 && w.pcacustomsamples.findIndex(sample => sample.split(':')[1] == group.sample && sample.split(':')[0] == group.group) >= 0) customsamples = w.pcaRerun
                            }
                        })
                    }
                    let params = {
                        groups: submitArr,
                        subId: subId,
                        custom: w.switches.custom ? true : false,
                        mode: w.modetype !== 'G25' ? w.modetype : undefined,
                        raw: w.modetype !== 'G25' ? true : false,
                        version: w.modetype !== 'G25' ? undefined : w.publicGroups[0].v,
                        unscaled: unscaled,
                        customsamples: customsamples
                    }
                    let query = getSamplesQuery
                    let results = []
                    let data = await w.$apollo.query({
                        query: query,
                        variables: {
                            params: JSON.stringify(params)
                        },
                        fetchPolicy: 'network-only'
                    })
                    let notdownloaded = []
                    if (data && data.data.getSamples && data.data.getSamples.samples) {
                        let buffer = Buffer.from(data.data.getSamples.samples, 'base64')
                        let jsonStr = w.$zlib.unzipSync(buffer).toString()
                        let samples = JSON.parse(jsonStr)
                        if (!w.isAdmin) {
                            notdownloaded = samples.filter(x => x.download == 1 && x.ogroup != w.user.username).map(x => {
                                return x.ogroup + ' ► ' + x.osample
                            })
                            samples = samples.filter(x => !x.download || x.ogroup == w.user.username)
                        }
                        samples.map(x => {
                            let result;
                            if (event === 'similarity') {
                                x.sample = x.sample.replace('_outlier', '')
                                let similar = x.group + ':' + x.sample
                                let coords = x.coords
                                let group = w.heatmapJSON.find(y => y.name === x.sample && y.group.split('|')[0] === x.group)
                                if (group) {
                                    let length = group.data.length
                                    similar = group.data.find(x => parseInt(x.y) == 2 * length)
                                    if (similar) {
                                        similar = (x.group + '[' + similar.x + ']:' + x.sample).replace(/ /g, '_')
                                    }
                                }
                                result = {
                                    'sample': similar
                                };
                            } else {
                                result = {
                                    'sample': x.group + ':' + x.sample + (w.switches.scaled && w.mode === 'G25' ? '_scaled' : '')
                                };
                            }
                            if (x.coords.length > 0) x.coords.map((y, i) => {
                                if (w.modetype !== 'G25' && w.modecomponents[w.modetype]) {
                                    result[w.modecomponents[w.modetype][i]] = parseFloat(y)
                                } else {
                                    result[`PC${i  + 1}`] = parseFloat(y)
                                }
                            })
                            results.push(result);
                        })
                    }
                    try {
                        if (results.length > 0) {
                            this.getXLS().then((res) => {
                                var wb = XLSX.utils.book_new();
                                var ws = XLSX.utils.json_to_sheet(results, {
                                    skipHeader: false
                                });
                                XLSX.utils.book_append_sheet(wb, ws, "results");
                                console.log(wb, name);
                                XLSX.writeFile(wb, name, {
                                    compression: true
                                });
                                this.$store.commit('change', {
                                    spinner: false
                                })
                                if (notdownloaded.length > 0) {
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'show',
                                        component: 'nav',
                                        params: {
                                            title: '',
                                            text: notdownloaded.length > 0 ? `Some samples filtered due to user preferences:<br/>${notdownloaded}` : `No downloadable samples found in current selection`,
                                            class: 'warning'
                                        }
                                    })
                                }
                            }).catch(err => {
                                this.$store.commit('change', {
                                    spinner: false
                                })
                                console.log(err)
                            })
                        } else {
                            this.$store.commit('change', {
                                spinner: false
                            })
                            console.log('Nothing to export..')
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: '',
                                    text: notdownloaded.length > 0 ? `Some samples filtered due to user preferences:<br/>${notdownloaded}` : `No downloadable samples found in current selection`,
                                    class: 'warning'
                                }
                            })
                        }
                    } catch (err) {
                        consoleWithNoSource(err)
                        this.$store.commit('change', {
                            spinner: false
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error!',
                                text: err,
                                class: 'failure'
                            }
                        })
                    }
                }
            } else {
                return
            }
        },
        debounceSearch(string) {
            if (string && typeof(string) == 'string') {
                string = string.replace(/<.*?>/g, '')
            }
            let w = this;
            let search = function() {
                let legendsearch = string && typeof(string) == 'string' ? true : false
                let term = string && typeof(string) == 'string' ? string : w.searchterm
                if (term && term.length > 2) {
                    let matched = []
                    let split = term.indexOf(',') >= 0 ? ',' : ' ';
                    let searchterm = legendsearch ? [term] : term.split(split);
                    searchterm.map(y => {
                        if (y.length > 2) {
                            if (legendsearch && y.split(':').length > 1) {
                                let submatched = w.sampleids.filter(x => x.id.toLowerCase() == y.toLowerCase())
                                matched = matched.concat(submatched)
                            } else if (legendsearch) {
                                if (y.includes('_[')) y = y.replace(/_/g, ' ')
                                let submatched = w.sampleids.filter(x => x.id.replace(/_/g, ' ').toLowerCase().indexOf(y.replace(/_/g, ' ').toLowerCase()) >= 0)
                                matched = matched.concat(submatched)
                            } else {
                                let submatched = w.sampleids.filter(x => x.id.toLowerCase().indexOf(y.toLowerCase()) >= 0)
                                matched = matched.concat(submatched)
                            }
                        }
                    })
                    if (matched.length > 0) {
                        let points = matched.map((x, i) => {
                            return {
                                curveNumber: matched[i].curve,
                                pointNumber: matched[i].point
                            }
                        })
                        PlotlyInstance.Fx.hover('pcaDiv', points)
                        w.hoverPoints = points
                    } else {
                        if (w.hoverPoints) {
                            PlotlyInstance.Fx.unhover('pcaDiv', w.hoverPoints)
                            w.hoverPoints = undefined
                        }
                    }
                    return matched.length
                } else {
                    if (w.hoverPoints) {
                        PlotlyInstance.Fx.unhover('pcaDiv', w.hoverPoints)
                        w.hoverPoints = undefined
                    }
                }
                return 0
            }
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                search()
            }, 400)
        },
        debounceSearch2(term) {
            let w = this;
            let search = function() {
                term = term || w.searchterm
                if (term && term.length > 2) {
                    let matched = []
                    let split = term.indexOf(',') >= 0 ? ',' : ' ';
                    let searchterm = term.split(split);
                    searchterm.map(y => {
                        if (y.length > 2) {
                            let submatched = w.sampleids.filter(x => x.id.toLowerCase().indexOf(y.toLowerCase()) >= 0)
                            matched = matched.concat(submatched)
                        }
                    })
                    if (matched.length > 0) {
                        let points = matched.map((x, i) => {
                            return {
                                curveNumber: matched[i].curve,
                                pointNumber: matched[i].point
                            }
                        })
                        PlotlyInstance.Fx.hover('pcaDiv', points)
                        w.hoverPoints = points
                    } else {
                        if (w.hoverPoints) {
                            PlotlyInstance.Fx.unhover('pcaDiv', w.hoverPoints)
                            w.hoverPoints = undefined
                        }
                    }
                    return matched.length
                } else {
                    if (w.hoverPoints) {
                        PlotlyInstance.Fx.unhover('pcaDiv', w.hoverPoints)
                        w.hoverPoints = undefined
                    }
                }
                return 0
            }
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                search()
            }, 400)
        },
        debounce: function(func, wait, timeout) {
            console.log(func, wait, timeout);
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        },
        async runAnalyzeResults() {
            this.recordEvent('analyzeButtonPCA', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            await analyzeResults(this, invokeAnalyzeResults, 'pca')
        },
        resetMode: function() {
            this.getUserSamples()
            this.markerState = false;
            if (this.modetype === 'G25') {
                this.customGroupModel = this.customGroupModel[0] && (this.customGroupModel[0].type !== 'G25' && this.customGroupModel[0].type != undefined) ? [] : this.customGroupModel[0] && (this.customGroupModel[0].type == 'G25' || this.customGroupModel[0].type == undefined) ? this.customGroupModel : []
                this.sampleModel = this.sampleModel[0] && (this.sampleModel[0].type == 'user' ? this.sampleModel[0].mode !== 'G25' : this.sampleModel[0].type != 'G25') ? [] : this.sampleModel[0] && (this.sampleModel[0].type == 'user' ? this.sampleModel[0].mode == 'G25' : this.sampleModel[0].type == 'G25') ? this.sampleModel : []
                this.interestedModel = this.interestedModel[0] && (this.interestedModel[0].type == 'user' ? this.interestedModel[0].mode !== 'G25' : this.interestedModel[0].type !== 'G25') ? [] : this.interestedModel[0] && (this.interestedModel[0].type == 'user' ? this.interestedModel[0].mode == 'G25' : this.interestedModel[0].type == 'G25') ? this.interestedModel : []
            } else {
                this.activeTab = 'custom'
                this.customGroupModel = this.customGroupModel && this.customGroupModel[0] && this.customGroupModel[0].type === 'G25' ? [] : this.customGroupModel && this.customGroupModel[0] ? this.customGroupModel.filter(x => x.type === 'raw' || x.type === this.modetype) : []
                this.sampleModel = this.sampleModel && this.sampleModel[0] ? this.sampleModel.filter(x => x.type === 'raw' || x.type === this.modetype) : []
                this.interestedModel = this.interestedModel && this.interestedModel[0] ? this.interestedModel.filter(x => x.type === 'raw' || x.type === this.modetype) : []
            }
            var name = this.user.username + ':plot:multiselect:modetype'
            localStorage.setItem(name, JSON.stringify(this.modetype));
            var name = this.user.username + ':plot:multiselect:customGroupModel'
            localStorage.setItem(name, JSON.stringify(this.customGroupModel));
            var name = this.user.username + ':plot:multiselect:sampleModel'
            localStorage.setItem(name, JSON.stringify(this.sampleModel));
            var name = this.user.username + ':plot:multiselect:interestedModel'
            localStorage.setItem(name, JSON.stringify(this.interestedModel));
        },
        resetGroups: function() {
            this.activeName = false;
            this.activeContent = false;
            this.markerState = false;
            this.activePath = false;
            this.titleText = false;
            this.yflipped = false;
            this.xflipped = false;
            this.customGroupModel = [];
            var name = this.user.username + ':plot:multiselect:customGroupModel'
            localStorage.setItem(name, JSON.stringify([]));
        },
        resetSamples: function() {
            var name = this.user.username + ':plot:multiselect:sampleModel'
            localStorage.setItem(name, JSON.stringify([]));
            this.sampleModel = [];
        },
        recordEvent: function(evt, meta) {
            meta.component = this.component;
            let ignore = ['routechange', 'setcredits', 'refreshcache', 'getuser', 'rerun', 'reset']
            this.$gtag.event(evt, meta);
            if (ignore.indexOf(evt.toLowerCase()) < 0) this.$genericevent.trackEvent(evt, meta);
        },
        appEvents: function(info) {
            if (typeof(info) === 'object' && (info.component === 'pca' || info.exec == 'refreshCache' || info.component === 'global')) {
                if (this[info.exec]) {
                    this[info.exec](info.params)
                }
            }
        },
        refreshCache(cache) {
            let w = this;
            let currentDT = Math.floor(Date.now() / 1000)
            if (typeof(cache) !== 'undefined' && cache.tos) localStorage.setItem('cacheVer', JSON.stringify(cache));
            var cache = typeof(cache) !== 'undefined' && cache.tos ? cache : localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                groups: {
                    g25: currentDT
                },
                samples: currentDT,
                tos: 0,
                calcVersion: currentDT
            }
            var UTF8to16 = function(convertMe) {
                var out = "";
                for (var i = 0; i < convertMe.length; i += 2) {
                    var charCode = convertMe.charCodeAt(i) * 256;
                    charCode += convertMe.charCodeAt(i + 1);
                    out += String.fromCharCode(charCode);
                }
                return out;
            }
            var stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
            w.getTreeData = async function(cache, stage) {
                let str = await this.$dbCache.getTreeDataCache(cache, 'pca', stage)
                return str
            }
            w.getTreeData(cache, stage).then(str => {
                w.treedata = str;
                console.log(`Treedata ready: ${Date.now() - window.__GenoStart} ms`)
            })
            w.getG25Groups = async function(cache, stage) {
                let str = await this.$dbCache.getG25Groups(cache, 'pca', stage)
                return str
            }
            w.getG25Groups(cache, stage).then(str => {
                w.publicGroups = str
            })
            w.getSampleGroups = async function(cache, stage) {
                let str = await this.$dbCache.getSampleGroups(cache, 'pca', stage)
                return str
            }
            w.getSampleGroups(cache, stage).then(str => {
                let customGroups = []
                str.forEach(x => {
                    let indexes = []
                    x.samples.map((sample, i) => {
                        x.originalGroup = sample.group
                        if (sample.alias) {
                            x.group = sample.alias
                            x.alias = sample.alias
                        }
                        if (sample.customgroup) {
                            indexes.push(i)
                            let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customGroups[customIndex].samples.push(sample)
                            } else {
                                customGroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    type: sample.mode,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    if (indexes.length > 0) {
                        x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                    }
                })
                this.customGroups = customGroups
                this.publicSamples = str;
            })
            w.getRawGroupsCache = async function(cache, stage) {
                let str = await this.$dbCache.getRawGroupsCache(cache, 'pca', stage)
                return str
            }
            w.getRawGroupsCache(cache, stage).then(str => {
                w.publicRawGroups = str;
            })
            w.getRawGroupedSamplesCache = async function(cache, stage) {
                let str = await this.$dbCache.getRawGroupedSamplesCache(cache, 'pca', stage)
                return str
            }
            w.getRawGroupedSamplesCache(cache, stage).then(str => {
                w.publicRawSamples = str;
            })
            this.$dbCache.getAll(cache, 'from pca', stage, ['getRawGroupedSamplesCache', 'getRawGroupsCache', 'getSampleGroups', 'getG25Groups', 'getTreeData'])
        },
        getUserSamples: async function(nextToken) {
            var w = this;
            if (!nextToken) {
                this.$store.commit('change', {
                    userSamples: []
                })
            }
            let currentSamples = nextToken ? this.$store.getters.get('userSamples') : []
            let proxy = (this.isAdmin && this.user && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.user.username) ? w.$store.getters.get('proxyUser') : false
            if (proxy) console.log('getting samples for ' + proxy)
            console.log(`getting${nextToken ? ' more ' : ' '}user samples...`)
            if (proxy || w.user && w.user.username) {
                try {
                    let variables = {
                        owner: proxy ? proxy : w.user.username,
                        type: w.modetype
                    }
                    if (nextToken) variables.nextToken = nextToken
                    let data = await w.$apollo.query({
                        query: queryByOwnerType,
                        variables: variables,
                        fetchPolicy: 'network-only'
                    })
                    if (data && data.data && data.data.queryByOwnerTypeIndex && data.data.queryByOwnerTypeIndex.items && data.data.queryByOwnerTypeIndex.items.length > 0) {
                        var samples = data.data.queryByOwnerTypeIndex.items
                        samples = currentSamples.concat(samples);
                        samples.sort((a, b) => a.sample.toLowerCase() > b.sample.toLowerCase() ? 1 : a.sample.toLowerCase() < b.sample.toLowerCase() ? -1 : 0)
                        samples.forEach((sample, index) => {
                            sample.sample = sample.sample
                            sample.alias = this.alias
                            sample.index = sample.group + ':' + sample.sample
                            sample.type = sample.type ? sample.type : 'G25';
                            sample.refs = ((sample.alias || sample.group) + ':' + sample.sample + (sample.ethicity || '') + (sample.origin || '')).toLowerCase();
                            sample.class = sample.outlier ? 'outlier user' : 'default user';
                        })
                        this.$store.commit('change', {
                            userSamples: samples
                        })
                        if (data.data.queryByOwnerTypeIndex.nextToken) await w.getUserSamples(data.data.queryByOwnerTypeIndex.nextToken)
                    } else {
                        console.log(`No samples associated with ${w.user.username} found`);
                        var userSamples = [{
                            group: w.user.username,
                            samples: []
                        }]
                        //this.userSamples = userSamples
                        this.$store.commit('change', {
                            userSamples: []
                        })
                    }
                    /*
                    setTimeout(() => {
                        if (this.publicSamples && this.publicSamples.length == 0) {
                            console.log('refreshing cache')
                            this.refreshCache()
                        }
                    }, 3000)
                    */
                } catch (error) {
                    console.log('getOwnerSamples', error);
                };
            }
        },
        init: function() {
            let w = this;
            w.initiated = true;
            requestIdleCallback(async () => {
                w.getUserSamples()
            })
        },
        rerun: async function(params, editable) {
            editable = editable ? true : false
            console.log(params);
            if (!params.data) {
                let key = params.type + '|' + params.path.replace(/\//, ':')
                params = await this.getShare(key, true)
                console.log('params', params)
            }
            if (params.published) {
                this.topics[params.path] = params.published
            }
            this.data = []
            this.layout = undefined
            this.customGroupModel = []
            this.sampleModel = []
            this.interestedModel = []
            this.annotationCLicked = false
            this.redraw = true;
            this.saveReady = false;
            this.spinner = true
            let evt = 'rightpanel';
            this.$root.$emit(evt, 'close');
            this.firstrun = false
            this.activePath = params.path;
            this.rerunswitch = params.replay || false;
            this.xflipped = params.xflipped ? params.xflipped : false
            this.yflipped = params.yflipped ? params.yflipped : false
            this.markerState = params.markerState ? params.markerState : false;
            this.lastMarkerState = this.markerState;
            this.activeName = params.name ? params.name : false;
            this.activeContent = params.content ? params.content : undefined;
            try {
                if (params.searchterm && params.mode) this.searchterm = params.searchterm
                this.activeTab = 'custom'
                this.modetype = params.modetype ? params.modetype : 'G25'
                setTimeout(() => {
                    if (params.calculator) {
                        this.customGroupModel = [params.calculator]
                    } else {
                        let customGroupModel = []
                        params.components.map(x => {
                            if (x.split(' [').length > 1) {
                                let customgroup = x.split(' [')[0]
                                let type = params.modetype
                                customGroupModel.push({
                                    class: 'default user',
                                    type: type,
                                    customgroup: customgroup,
                                    ethnicity: x,
                                    label: x,
                                    samples: 1
                                })
                            } else {
                                if (this.groupOptions.findIndex(group => group.label === x.replace(/ /, '_')) >= 0) {
                                    customGroupModel.push(this.groupOptions.find(group => group.label === x.replace(/ /, '_')))
                                }
                            }
                        })
                        this.customGroupModel = customGroupModel.filter(x => x !== undefined)
                    }
                    this.syncStore('multiselect.customGroupModel')
                    let sampleModel = []
                    params.categories.map(x => {
                        if (params.samples) {
                            let entityType = undefined
                            if (params.samples.findIndex(y => y == x) >= 0) entityType = 'user'
                            let alias = this.sampleJSON.find(s => s.originalGroup == x.split(':')[0]) || this.publicSamples.find(s => s.originalGroup == x.split(':')[0])
                            let sample = {
                                index: x,
                                group: alias ? alias.group : x.split(':')[0],
                                sample: x.split(':')[1],
                                entityType: entityType
                            }
                            if (alias) {
                                let found = alias.samples.find(s => s.index == x)
                                sample = found || sample
                            }
                            sampleModel.push(sample)
                        } else {
                            if (x.split(':').length === 1) {
                                let sample = this.sampleOptions[0].samples.find(s => s.sample === x)
                                if (sample) sampleModel.push(sample)
                            } else if (x.split(':').length === 2) {
                                console.log('xxxxx', x)
                                let index = x.split(':')[0] == this.user.username ? 0 : this.sampleOptions.findIndex(s => s.group === x.split(':')[0])
                                if (index >= 0) {
                                    let sample = this.sampleOptions[index].samples.find(s => s.sample === x.split(':')[1])
                                    if (sample) sampleModel.push(sample)
                                }
                            }
                        }
                    })
                    console.log('cats', sampleModel);
                    this.sampleModel = sampleModel.filter(x => x !== undefined)
                    this.syncStore('multiselect.sampleModel')
                    let refModel = []
                    let w = this;
                    params.reference.map(x => {
                        if (params.samples && params.samples.findIndex(y => y == x) >= 0) {
                            let alias = w.sampleJSON.find(a => a.originalGroup == x.split(':')[0]) || w.publicSamples.find(a => a.originalGroup == x.split(':')[0])
                            let sample = {
                                index: x,
                                group: x.split(':')[0],
                                sample: x.split(':')[1],
                                entityType: 'user'
                            }
                            if (alias) {
                                let found = alias.samples.find(s => s.index == x)
                                if (found) sample = found;
                            }
                            refModel.push(sample)
                        } else {
                            let group = this.groupsPlusOptions.find(s => s.id === x.split(':')[0] || s.originalGroup == x.split(':')[0])
                            if (group) {
                                let sample = group.samples.find(s => s.index === x)
                                if (sample) refModel.push(sample)
                            }
                        }
                    })
                    this.interestedModel = refModel.filter(x => x !== undefined)
                    this.syncStore('multiselect.interestedModel')
                    this.spinner = false;
                    this.switches.all = params.labelGroups ? true : false
                    this.switches.editPCA = editable ? true : params.editPCA ? true : false
                    this.switches.sort = params.sorted ? true : false
                    this.switches.averaged = params.averaged ? true : false
                    var name = this.user.username + ':plot:multiselect:modetype'
                    localStorage.setItem(name, JSON.stringify(this.modetype));
                    var name = this.user.username + ':plot:multiselect:customGroupModel'
                    localStorage.setItem(name, JSON.stringify(this.customGroupModel));
                    var name = this.user.username + ':plot:multiselect:sampleModel'
                    localStorage.setItem(name, JSON.stringify(this.sampleModel));
                    var name = this.user.username + ':plot:multiselect:interestedModel'
                    return;
                }, 500)
                let suffix = params.path
                this.mode = params.mode ? '2d' : '3d'
                let data = params.data
                setTimeout(() => {
                    this.layout = params.layout
                    this.titleText = this.layout.title ? this.layout.title.text : false;
                    this.activeTitle = this.layout.title ? this.layout.title.text : false;
                    this.data = data;
                    this.spinner = false
                }, 100)
            } catch (err) {
                console.log(err);
                this.spinner = false
                setTimeout(() => {
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: "Error",
                            text: "Unable to reset  PCA<br>Perhaps some of the groups or samples are no longer available.",
                            class: 'warning'
                        }
                    })
                }, 300)
            }
        },
        getLocalStorage: function() {
            try {
                if (localStorage.getItem(`${this.user.username}:plot:mapswitch`)) this.surface = JSON.parse(localStorage.getItem(`${this.user.username}:plot:mapswitch`))
                if (localStorage.getItem(`${this.user.username}:plot:multiselect:modetypel`)) this.modetype = JSON.parse(localStorage.getItem(`${this.user.username}:plot:multiselect:modetype`))
                if (localStorage.getItem(`${this.user.username}:plot:multiselect:customGroupModel`)) this.customGroupModel = JSON.parse(localStorage.getItem(`${this.user.username}:plot:multiselect:customGroupModel`))
                if (localStorage.getItem(`${this.user.username}:plot:multiselect:sampleModel`)) this.sampleModel = JSON.parse(localStorage.getItem(`${this.user.username}:plot:multiselect:sampleModel`))
                if (localStorage.getItem(`${this.user.username}:plot:multiselect:interestedModel`)) this.interestedModel = JSON.parse(localStorage.getItem(`${this.user.username}:plot:multiselect:interestedModel`))
                if (localStorage.getItem(`${this.user.username}:plot:groupModel`) && this.customGroupModel.length === 0) {
                    this.groupModel = JSON.parse(localStorage.getItem(`${this.user.username}:plot:groupModel`))
                    //this.$refs.tree.setCheckedNodes(JSON.parse(localStorage.getItem(`${this.user.username}:plot:groupModel`)))
                }
            } catch (err) {
                console.log(err)
            }
        },
        setSurface: function() {
            //this.switches.all = true
            //this.syncStore('switches.all')
            let name = this.user.username + ':plot:mapswitch'
            localStorage.setItem(name, JSON.stringify(this.surface));
            if (this.data && this.data.length > 0) {
                //this.loadPCA(true);
            }
        },
        setMesh: function(evt) {
            if (this.data && this.data.length > 0) {
                this.loadPCA(true);
            }
        },
        setMode: function(evt) {
            let w = this;
            if (this.data && this.data.length > 0) {
                if (window.PlotlyInstance) {
                    PlotlyInstance.Fx.unhover('pcaDiv')
                }
                this.loadPCA(true);
            }
        },
        getInitialColorMode(value) {
            const persistedColorPreference = value == 'system' ? false : value
            const hasPersistedPreference = typeof persistedColorPreference === 'string';
            if (hasPersistedPreference) {
                this.setColors(persistedColorPreference)
                return persistedColorPreference;
            }
            const mql = window.matchMedia('(prefers-color-scheme: dark)');
            const hasMediaQueryPreference = typeof mql.matches === 'boolean';
            if (hasMediaQueryPreference) {
                this.setColors(mql.matches ? 'dark' : 'light')
                return mql.matches ? 'dark' : 'light';
            }
            this.setColors('light')
            return 'light';
        },
        setColors(value) {
            if (value == 'dark') {
                document.documentElement.style.setProperty('--bg-color', '#181818');
                document.documentElement.style.setProperty('--color', '#dfdfdf');
            } else {
                document.documentElement.style.setProperty('--bg-color', '#f2f2f2');
                document.documentElement.style.setProperty('--color', '#444444');
            }
        },
        toggleTheme() {
            let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            this.syncStore('slider.theme.' + value)
            this.plotId = Date.now();
            let genoTheme = this.getInitialColorMode(value)
            localStorage.setItem("genoTheme", genoTheme);
            let wn = document.getElementById('discussionframe')
            if (wn && wn.contentWindow) {
                wn = wn.contentWindow
                if (value == 'system') {
                    wn.postMessage({
                        action: 'removeStorage',
                        content: {
                            key: 'genoTheme'
                        },
                        source: 'genoplot.com'
                    }, '*')
                } else {
                    wn.postMessage({
                        action: 'setStorage',
                        content: {
                            key: 'genoTheme',
                            value: genoTheme
                        },
                        source: 'genoplot.com'
                    }, '*')
                }
            }
            const el = document.body;
            if (el.classList.contains('dark') && genoTheme != 'dark') {
                this.theme = false
                setTimeout(() => {
                    el.classList.remove('dark')
                }, 1)
            } else if (genoTheme == 'dark') {
                this.theme = true
                setTimeout(() => {
                    el.classList.add('dark')
                }, 1)
            }
        },
        share: function(obj) {
            let w = this;
            let functions = {
                facebook: function(params) {
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'facebook',
                        shareQuote: w.saveReady2 ? ('my Genoplot ' + params.title) : 'my Genoplot ' + w.layout.title.text,
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/pca/?share=' + path + '#' + theme,
                        shareDesc: "Genetic Ancestry Modeling",
                        shareTitle: "Global 25 ancestry models"
                    }
                },
                twitter: function(params) {
                    let shareHash = 'genoplot,genetics,geneology,ancestry,PCA'
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'twitter',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: w.saveReady2 ? ('my Genoplot ' + params.title) : 'my Genoplot ' + w.layout.title.text,
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/pca/?share=' + path + '#' + theme,
                    }
                },
                reddit: function(params) {
                    let shareHash = 'genoplot,genetics,ancestry,PCA'
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'reddit',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: w.saveReady2 ? ('my Genoplot ' + params.title) : 'my Genoplot ' + w.layout.title.text,
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/pca/?share=' + path + '#' + theme,
                    }
                }
            }
            functions[obj.name](obj.params)
        },
        saveShare: function(params) {
            //localStorage.setItem('pcaRerun', 'pca|Genoplot:1797cd305a3')
            let recordSave = params == 'save' ? `save-${this.component}` : `share-${params}-${this.component}`
            this.recordEvent(recordSave, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (this.saveReady2) {
                let title = this.shareTitle ? (this.shareTitle.toLowerCase().includes('pca') ? this.shareTitle : 'PCA for ' + this.shareTitle) : ''
                let url = this.src
                if (params == 'save') {
                    this.showshare = false;
                    let url = this.src.split('/').reverse()
                    let id = url[0]
                    id = id.substr(0, id.length - 1)
                    let user = url[1].replace(/\#/, '')
                    let component = url[2]
                    let rerun = `${component}|${user}:${id}`
                    this.pcaRerun = `${rerun.split('|')[0]}-shares.genoplot.com/${rerun.split('|')[1].replace(/:/,'/')}/samples`
                    let sharekey = rerun
                    this.getShare(sharekey);
                } else {
                    this.share({
                        name: params,
                        params: {
                            title: title,
                            shareUrl: url
                        }
                    })
                }
                return;
            }
            let w = this;
            params = params || 'save'
            if (w.plotId !== w.lastShared || !w.currentShare) {
                let version = w.customGroupModel.findIndex(x => x.v !== undefined)
                version = (version >= 0 ? w.customGroupModel[version].v : 0)
                let samples = []
                let usersamples = {}
                w.customGroupModel.map(x => {
                    if (x.entityType === 'user' || x.type === 'user' || x.customgroup) {
                        if (x.customgroup) {
                            if (!usersamples[x.label]) {
                                samples.push(x.label)
                                usersamples[x.label] = true
                            }
                        } else {
                            if (!usersamples[x.index]) {
                                samples.push(x.index)
                                usersamples[x.index] = true;
                            }
                        }
                    }
                })
                w.sampleModel.map(x => {
                    if (x.entityType === 'user' || x.type === 'user') {
                        if (!usersamples[x.index]) {
                            samples.push(x.index)
                            usersamples[x.index] = true;
                        }
                    }
                })
                w.createNew = true;
                if (w.activePath) {
                    console.log(`Existing share: ${w.activePath}`)
                }
                //console.log(w.activePath.split('/').length, w.activePath.split('/')[0], w.user.username)
                if (w.activePath && w.activePath.split('/').length > 1 && (w.activePath.split('/')[0] == w.user.username || w.activePath.split('/')[0] == w.alias)) {
                    let buttons = [{
                            title: 'Update',
                            handler: () => {
                                w.createNew = false;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Create New',
                            handler: () => {
                                w.createNew = true;
                                w.rerunswitch = false;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }
                    ]
                    w.$modal.show('dialog', {
                        title: 'Update or Create New?',
                        text: 'Do you want to save to existing Plot<br/>or save as a new Plot?',
                        class: undefined,
                        buttons: buttons
                    })
                } else {
                    saveShare()
                }

                function saveShare() {
                    let layout = JSON.parse(JSON.stringify(w.layout))
                    if (layout.annotations && layout.annotations.length > 0) {
                        layout.annotations.map(x => x.captureevents = false)
                    }
                    let payload = {
                        layout: layout,
                        data: JSON.parse(JSON.stringify(w.data)),
                        user: w.user.username,
                        date: Date.now(),
                        averaged: w.switches.averaged,
                        editable: w.switches.editPCA,
                        replay: w.rerunswitch,
                        sorted: w.switches.sort,
                        labelGroups: w.switches.all,
                        modetype: w.modetype,
                        markerState: w.lastMarkerState,
                        searchterm: w.searchterm,
                        version: version,
                        xflipped: w.xflipped,
                        yflipped: w.yflipped,
                        samples: samples,
                        shareType: params,
                        reference: w.interestedModel.map(x => x.index),
                        components: w.customGroupModel.length > 0 ? w.customGroupModel.map(x => x.label) : w.groupModel.map(x => x.label),
                        categories: w.sampleModel.map(x => x.index)
                    }
                    if (w.alias && !(w.activeName && !w.createNew) || w.alias && !w.createNew && w.activePath && w.activePath.split('/')[0] == w.alias) {
                        payload.alias = w.alias;
                    }
                    if (w.calculator && w.customGroupModel[0].calculator) {
                        let calculator = {
                            ...w.customGroupModel[0]
                        }
                        try {
                            if (typeof(calculator.components) == 'string') {
                                calculator.components = JSON.parse(calculator.components)
                            }
                        } catch (err) {
                            calculator.components = []
                        }
                        delete calculator.settings
                        payload.calculator = calculator
                    }
                    if (w.pcacustomsamples && w.pcaRerun && samples.length > 0) {
                        samples.map(x => {
                            if (w.pcacustomsamples.findIndex(y => y == x) >= 0) payload.customsamples = w.pcaRerun
                        })
                    }
                    let defaultName = w.activeName && !w.createNew && w.titleText === w.activeTitle ? w.activeName : w.activeName && !w.createNew && w.titleText !== w.activeTitle ? w.titleText : w.titleText && w.titleText.indexOf('D PCA Custom Groups(') < 0 ? w.titleText : (payload.categories && payload.categories[0] ? (payload.categories[0].split(':').length > 1 ? payload.categories[0].split(':')[1].split('@')[0] : payload.categories[0].split(' ').reverse()[0]).split('@')[0] : '') + (payload.components ? '| ' + payload.components.join(', ').replace(/_/g, ' ') : '')
                    defaultName = defaultName.replace(/(<([^>]+)>)/gi, "")
                    let postContent = w.activeContent && !w.createNew ? w.activeContent : undefined
                    if (w.subType > 0) {
                        let buttons = [{
                                title: 'OK',
                                handler: () => {
                                    try {
                                        let input = document.getElementById('saveDialog')
                                        defaultName = input.textContent || defaultName
                                        w.activeName = w.createNew ? false : defaultName
                                        w.activeContent = w.createNew ? undefined : postContent
                                        let rerunswitch = document.getElementById('rerunSwitch')
                                        w.rerunswitch = rerunswitch.checked || false
                                        let post = document.getElementById('shared-description')
                                        postContent = post.value || undefined
                                        if (!defaultName || (defaultName && defaultName.length < 16)) {
                                            w.$modal.show('dialog', {
                                                title: 'Title is too short',
                                                text: 'Please set a longer title. Titles need to be at least 16 characters long. You are short by ' + (16 - defaultName.length) + ' characters',
                                            })
                                        } else {
                                            save(defaultName)
                                            w.$modal.hide('saveDialog');
                                        }
                                    } catch (err) {
                                        w.$modal.show('dialog', {
                                            class: 'warning',
                                            title: 'Error',
                                            text: err
                                        })
                                        console.log(err);
                                    }
                                } // Button click handler
                            },
                            {
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('saveDialog');
                                } // Button click handler
                            }
                        ]
                        if (w.createNew || !w.createNew) {
                            w.$modal.show('saveDialog', {
                                payload: {
                                    ...payload,
                                    ...{
                                        name: defaultName,
                                        type: 'pca',
                                        content: postContent
                                    }
                                },
                                buttons: buttons
                            })
                            setTimeout(() => {
                                let input = document.getElementById('saveDialog');
                                if (input && w.createNew) {
                                    input.focus();
                                    w.selectElementContents(input);
                                }
                            }, 100)
                        } else {
                            save()
                        }
                    } else {
                        save()
                    }

                    async function save(defname) {
                        let name = w.alias ? w.alias : w.user.username;
                        let path = !w.createNew && w.activePath ? w.activePath : `${name}/${Date.now().toString(16)}`
                        payload.name = defname
                                        console.log('defaultName',  defname);
                        if (w.subType > 0) {
                            w.activePath = path;
                            w.activeName = defaultName;
                        }
                        if (w.topics && w.topics[path] && !w.createNew) payload.published = w.topics[path]
                        w.spinner = true
                        let theme = w.theme ? 2 : 1
                        let type = 'pca'
                        payload.path = path
                        payload.replay = w.rerunswitch
                        payload.theme = theme
                        payload.updated = w.createNew ? false : true;
                        payload.type = type
                        payload.content = postContent
                        payload.mode = !w.plotMode
                        payload.groupType = w.customGroupModel.length > 0 ? 'custom' : 'preset'
                        if (w.customGroupModel.length === 0) payload.treeData = w.$store.getters.get('plotGroupSamples')
                        let contentType = 'application/json'
                        w.spinner = true
                        let sigparams = {
                            filePath: path,
                            fileType: type,
                            shareType: payload.shareType,
                            email: w.user.email,
                            username: w.user.username,
                            contentType: contentType,
                            jsonPayload: payload
                        }
                        if (w.env && typeof(w.env) == 'string' && (w.env == 'development' || w.env == 'staging')) {
                            sigparams.debug = true
                            sigparams.env = 'dev'
                        }
                        console.log('sigparans', sigparams);
                        let data = await w.$apollo.query({
                            query: getS3SignatureQuery,
                            variables: {
                                params: JSON.stringify(sigparams)
                            },
                            fetchPolicy: 'network-only'
                        })
                        if (data && data.data && data.data.gets3Signature && data.data.gets3Signature.result) {
                            let result = JSON.parse(data.data.gets3Signature.result);
                            if (result.url && !result.uploaded) {
                                let signedUrl = result.url;
                                let options = {
                                    headers: {
                                        'Content-Type': contentType,
                                        'Content-Encoding': 'gzip'
                                    }
                                }
                                axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options)
                                    .then(function(result) {
                                        w.spinner = false
                                        w.currentShare = {
                                            params: params,
                                            theme: theme,
                                            path: path
                                        }
                                        w.lastShared = w.plotId
                                        showShare(params, path, theme)
                                    })
                                    .catch(function(err) {
                                        w.spinner = false
                                        console.log(err);
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'show',
                                            component: 'nav',
                                            params: {
                                                title: "Error",
                                                text: "unable to save pca",
                                                class: 'warning'
                                            }
                                        })
                                    });
                            } else if (result.uploaded) {
                                w.spinner = false
                                w.currentShare = {
                                    params: params,
                                    theme: theme,
                                    path: path
                                }
                                w.lastShared = w.plotId
                                showShare(params, path, theme)
                            } else {
                                w.spinner = false
                                console.log(result);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to save pca",
                                        class: 'warning'
                                    }
                                })

                            }
                        } else {
                            w.spinner = false
                            console.log(data);
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: "Error",
                                    text: "unable to save PCA",
                                    class: 'warning'
                                }
                            })
                        }
                    }

                    function save2() {
                        let name = w.alias ? w.alias : w.user.username;
                        let path = !w.createNew && w.activePath ? w.activePath : `${name}/${Date.now().toString(16)}`
                        payload.name = defaultName
                        if (w.subType > 0) {
                            w.activePath = path;
                            w.activeName = defaultName;
                        }
                        w.spinner = true
                        let theme = w.theme ? 2 : 1
                        let type = 'pca'
                        payload.path = path
                        payload.theme = theme
                        payload.updated = w.createNew ? false : true;
                        payload.type = type
                        payload.mode = !w.plotMode
                        payload.groupType = w.customGroupModel.length > 0 ? 'custom' : 'preset'
                        if (w.customGroupModel.length === 0) payload.treeData = w.$store.getters.get('plotGroupSamples')
                        let contentType = 'application/json'
                        axios.post('https://genoplot.com/api/s3upload', {
                                filePath: path,
                                fileType: type,
                                contentType: contentType
                            })
                            .then(function(result) {
                                var signedUrl = result.data.url;
                                var options = {
                                    headers: {
                                        'Content-Type': contentType,
                                        'Content-Encoding': 'gzip'
                                    }
                                };
                                return axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options);
                            })
                            .then(function(result) {
                                w.spinner = false
                                w.currentShare = {
                                    params: params,
                                    theme: theme,
                                    path: path
                                }
                                w.lastShared = w.plotId
                                showShare(params, path, theme)
                            })
                            .catch(function(err) {
                                w.spinner = false
                                console.log(err);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to save PCA",
                                        class: 'warning'
                                    }
                                })
                            });
                    }
                }
            } else {
                showShare(params, w.currentShare.path, w.currentShare.theme)
            }

            function showShare(params, path, theme) {
                if (params === 'save') {
                    let url = 'https://genoplot.com/shared/pca/?share=' + path + '#' + theme
                    let buttons = [{
                        title: "Copy URL",
                        handler: (i, event) => {
                            copy(url)
                            document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                        }
                    }, {
                        title: '<a href="mailto:?subject=my Genoplot PCA&body=' + url + '" >Email</a>'
                    }, {
                        title: 'Close',
                        default: true
                    }]
                    w.$modal.show('dialog', {
                        title: 'Share',
                        text: "You can now share this PCA from this <a target='_blank' href='https://genoplot.com/shared/pca/?share=" + path + '#' + theme + "'>link</a>",
                        //text: "You can now share this PCA from this <a target='_blank' href='http://localhost:3000/shared/pca/?share=" + path + "#2'>link</a>",
                        buttons: buttons,
                        clickToClose: false,
                        class: 'alert',
                        beforeClosed: function(event) {
                            console.log('closing', event)
                        }
                    })
                } else {
                    w.share({
                        name: params,
                        params: {
                            theme: theme,
                            path: path
                        }
                    })
                }
            }
        },
        loadPCA: function(auto) {
            console.log('called loadPCA', auto, 'theme', this.theme);
            if (this.layout && this.layout.annotations && this.layout.annotations.length == 0) this.layout = undefined;
            this.startedLoad = Date.now()
            this.annotationCLicked = false
            this.redraw = true
            this.runCalc = false;
            this.saveReady = false;
            this.colorindex = 0;
            this.recordEvent('runPCA', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            let existingAnnotations = this.layout && this.layout.scene && this.layout.scene.annotations ? this.layout.scene.annotations : this.layout && this.layout.annotations ? this.layout.annotations : []
            existingAnnotations = existingAnnotations.filter(x => x.clicked)
            let existingTitle = this.existingTitle ? this.existingTitle : auto && this.layout && this.layout.title ? this.layout.title.text.replace(/2d/ig, this.mode.toUpperCase()).replace(/3d/ig, this.mode.toUpperCase()) : false;
            this.existingTitle = false;
            if (this.titleText && !existingTitle) existingTitle = this.titleText.replace(/2d/ig, this.mode.toUpperCase()).replace(/3d/ig, this.mode.toUpperCase());
            let w = this;
            w.plotId = Date.now();
            w.spinner = true
            let evt = 'rightpanel';
            w.$root.$emit(evt, 'close');
            let samplesize = this.customGroupModel[2] ? this.customGroupModel.map(x => x.samples).reduce((x, y) => x + y, 0) : !this.customGroupModel[0] ? 20 : 0
            let switches = samplesize < 20 && !this.calculator ? {
                plotSwitches: {
                    averaged: false,
                    median: false,
                    all: true
                }
            } : {
                plotSwitches: this.switches
            }
            let elname = this.user.username + ':plot:switches'
            localStorage.setItem(elname, JSON.stringify(switches));
            this.$store.commit('change', switches)
            let cline = w.groupModel[0] && w.groupModel[0].id.split(':')[1] ? w.groupModel[0].id.split(':')[1] : 'All'
            let age = w.groupModel[0] && w.groupModel[0].age ? w.groupModel[0].age : 'All'
            let name = this.customGroupModel && this.customGroupModel.length > 0 ? 'Custom Groups' : w.groupModel[0] && w.groupModel[0].title ? w.groupModel[0].title : ''
            let averaged = w.switches.averaged ? ' (averages only)' : w.switches.median ? ' (medians only)' : ''

            if (w.sampleModel.length > 0) {
                let rawtext = []
                w.sampleModel.map(x => {
                    rawtext.push(`${x.alias ? x.alias : x.group} ► ${x.sample}`.replace(/_/g, ' '))
                })
                w.rawtext = rawtext
            }
            loadData()

            function loadData() {
                w.rawtext = w.rawtext || []
                w.pcaClass = 'default'
                setTimeout(async () => {
                    try {
                        var {
                            x,
                            y,
                            z,
                            d,
                            c,
                            t,
                            variances
                        } = await w.getJSON(cline, age);
                        if (typeof y[0] === "undefined" || typeof z[0] === "undefined") {
                            w.spinner = false;
                            console.log('no data');
                            let evt = 'rightpanel';
                            w.$root.$emit(evt, 'open');
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: "Error",
                                    text: "Data not found for custom group(s)",
                                    class: 'warning'
                                }
                            })
                            return false
                        }
                        let textArray = Array.from(t);
                        let point = t.map((j, i) => `${c[i]} ► ${j}`.replace(/_/g, ' '));
                        let ids = t.map((j, i) => `${c[i]}:${j}`);
                        if (d && d.length === t.length) {
                            t = t.map((j, i) => `${c[i].split('|')[0]} ► ${j.split('@')[0]}<br><i style="opacity: 1">distance: ${(d[i] * 100).toFixed(2)}</i>`.replace(/_/g, ' '));
                        } else {
                            t = point
                        }
                        let multiplier = w.interestedModel[0] ? 20 : 10
                        let modegroup1 = ['G25', 'EUROGENESK13', 'DODECADK12B', 'GLOBE13', 'K36']
                        let modegroup2 = ['G25', 'EUROGENESK13', 'GLOBE13', 'K36']
                        x = !w.xflipped ? (modegroup1.indexOf(w.modetype) >= 0 && !w.switches.averaged ? x : x.map(x => -1 * x)) : (modegroup1.indexOf(w.modetype) >= 0 && !w.switches.averaged ? x.map(x => -1 * x) : x)
                        y = !w.yflipped ? (modegroup2.indexOf(w.modetype) >= 0 && !w.switches.averaged ? y : y.map(y => -1 * y)) : (modegroup2.indexOf(w.modetype) >= 0 && !w.switches.averaged ? y.map(y => -1 * y) : y)
                        z = modegroup2.indexOf(w.modetype) >= 0 && !w.switches.averaged ? z : z.map(z => -1 * z)
                        //x = w.xflipped ? x.map( x => -1 * x ) : x
                        //x = w.yflipped ? y.map( x => -1 * x ) : y
                        //y = w.modetype === 'G25' ? y : y.map( x => -1 * x )
                        //z = w.modetype === 'G25' ? z : z.map( x => -1 * x )
                        let rawtext = w.rawtext ? w.rawtext.map(x => x.split('@')[0]) : []
                        console.log('rawtest', rawtext);
                        var o = point.map(j => rawtext.indexOf(j) >= 0 ? "x" : "circle")
                        //var s = d.map(a => 1 - a).map((a, i) => o[i] && o[i] === "x" ? 5 : Math.ceil(10 * (Math.pow(a, 3) * multiplier)) / 10)
                        //var s = d.map(a => (a < 0.02 ? 1 - 0.2 : (1 - a))).map((a, i) => o[i] && o[i] === "x" ? 5 : Math.ceil(10 * (Math.pow(a, 2) * multiplier)) / 10)
                        var s = d.map(x => x <= 0.005 ? multiplier : x <= 0.01 ? multiplier * 0.95 : x <= 0.03 ? multiplier * 0.9 : x <= 0.05 ? multiplier * 0.85 : x <= 0.07 ? multiplier * 0.8 : x <= 0.1 ? multiplier * 0.75 : x <= 0.12 ? multiplier * 0.6 : x <= 0.15 ? multiplier * 0.5 : multiplier * 0.4)
                        c = c.map(x => x.replace(/_/g, ' '))
                        if (s.length === 0) s = t.map(x => t.length <= 50 ? 16 : t.length <= 100 ? 14 : 12)
                        if (w.mode === '3d') {
                            w.config = {
                                responsive: true,
                                displaylogo: false,
                            }
                            let groups = c.map((grp, i) => {
                                grp = w.rawtext.findIndex(x => x.replace(/ ► /g, ':').replace(/ /g, '_') == ids[i].replace(/ /g, '_')) >= 0 ? ids[i].split(':')[1].replace(/_/g, ' ') : grp.split('|')[0]
                                grp = grp.split('|')[0]
                                return grp
                            })
                            w.data = [{
                                type: "scatter3d",
                                mode: "markers",
                                name: '3D',
                                x: x,
                                y: y,
                                z: z,
                                d: d,
                                id: ids,
                                text: t,
                                annotations: [],
                                textposition: 'top',
                                hoverinfo: 'text',
                                marker: {
                                    size: s,
                                    symbol: o,
                                    opacity: 1,
                                    line: {
                                        color: 'white',
                                        width: 2,
                                        opacity: 1
                                    }
                                },
                                transforms: [{
                                    type: "groupby",
                                    //groups: c.map((group, i) => w.rawtext.findIndex(x => x.replace(/ ► /g, ':').replace(/ /g, '_') == ids[i]) >= 0 ? ids[i].replace(/:/, ' ► ').replace(/_/g, ' ') : group.split('|')[0]),
                                    groups: groups,
                                }],
                                surfaceaxis: w.surface ? 2 : -1,
                                opacity: w.surface ? 0.6 : 1
                                //projection: { x: { show: true, opacity: 0.1 }, y: { show: true, opacity: 0.1  }, z: { show: true, opacity: 0.1 } }
                            }, ]
                            if (w.mesh) {
                                w.data.push({
                                    name: 'mesh',
                                    alphahull: 5,
                                    opacity: 0.05,
                                    type: 'mesh3d',
                                    x: x,
                                    y: y,
                                    z: z
                                })
                            }
                            w.layout = {
                                mode: '3d',
                                title: {
                                    text: existingTitle ? existingTitle : '3D PCA ' + name + averaged + ` (${w.modes.find( x => x.value == w.modetype)['label']})`,
                                    font: {
                                        color: 'black'
                                    },
                                    xanchor: w.screenWidth < 620 ? 'center' : 'left',
                                    x: w.screenWidth < 620 ? null : 0.045,
                                    //y: w.screenWidth < 620 ?  0.95 : 0.93,
                                    y: 0.06,
                                    yanchor: 'bottom'
                                },
                                local: true,
                                legend: {
                                    y: 1,
                                    x: 1,
                                    itemclick: false,
                                    xanchor: 'right',
                                },
                                margin: {
                                    autoexpand: false,
                                    l: 0,
                                    r: 0,
                                    b: 30,
                                    t: 2,
                                    pad: 0,
                                },
                                dragmode: 'orbit',
                                scene: {
                                    xaxis: {
                                        title: "PC1 (" + (variances[0] * 100).toFixed(2) + "%)",
                                        spikecolor: '#1fe5bd'
                                    },
                                    yaxis: {
                                        title: "PC2 (" + (variances[1] * 100).toFixed(2) + "%)",
                                        spikecolor: '#1fe5bd'
                                    },
                                    zaxis: {
                                        title: "PC3 (" + (variances[2] * 100).toFixed(2) + "%)",
                                        spikecolor: '#1fe5bd'
                                    },
                                    annotations: [],
                                    camera: {
                                        "up": {
                                            "x": -0.33703839141927183,
                                            "y": -0.3287544477889557,
                                            "z": 0.8822276552956662
                                        },
                                        "center": {
                                            "x": -0.10206232675035362,
                                            "y": 0.22557410369675956,
                                            "z": -0.22244999572187967
                                        },
                                        "eye": {
                                            "x": 1.2333325169229772,
                                            "y": 1.3798212156082017,
                                            "z": 0.6422363948494513
                                        }
                                    }, //zoomed-out
                                    camera: {
                                        eye: {
                                            x: 0.,
                                            y: 0.,
                                            z: 1.8
                                        },
                                        up: {
                                            x: 0.,
                                            y: 0.,
                                            z: 0
                                        },
                                        center: {
                                            x: 0.,
                                            y: 0.,
                                            z: 0
                                        }
                                    }, //2d
                                    //camera: {"up":{"x":-0.33275217425281084,"y":-0.32485348983992113,"z":0.8852944146829638},"center":{"x":-0.030028258175114186,"y":0.13352145033165344,"z":-0.21487955659692365},"eye":{"x":1.169971741824886,"y":1.1935214503316538,"z":0.6251204434030766}}, //zoomed-in
                                    //camera: { center: { x: -0.15, y: 0.21, z: -0.14 }, eye: { x: 1.05, y: 1.27, z: 0.70, }, up: { x: -0.35, y: -0.34, z: 0.87 } }, //default
                                }
                            }
                            textArray.map((txt, i) => {
                                if (txt === 'Average' || o[i] == 'x') {
                                    let annotation = {
                                        clicked: false,
                                        captureevents: w.switches.editPCA ? true : false,
                                        text: o[i] == 'x' ? `<b>${t[i].split(' ► ')[1]}</b>` : `<b>${c[i].split('|')[0]}</b>`,
                                        x: parseFloat(x[i]),
                                        y: parseFloat(y[i]),
                                        z: parseFloat(z[i]),
                                        id: ids[i],
                                        xanchor: "top",
                                        showarrow: true,
                                        arrowhead: 7,
                                        arrowsize: 1,
                                        arrowwidth: 1,
                                        arrowcolor: '#00000000',
                                        ax: 0,
                                        ay: -10,
                                        font: {
                                            color: w.theme ? '#ddd' : '#555'
                                        },
                                        bgcolor: w.theme ? "#00000055" : "#f2f2f2aa",
                                        borderpad: 4,
                                        borderradius: 5,
                                        visible: w.switches.all ? true : false,
                                        bordercolor: w.theme ? "#f2f2f211" : '#00000011'
                                    }
                                    if (o[i] == 'x') {
                                        let annotationMod = {
                                            bgcolor: "#f2f2f2aa",
                                            bordercolor: w.theme ? '#ffffff55' : '#00000011',
                                            arrowcolor: w.theme ? '#ddd' : '#00000055',
                                            ax: 0,
                                            ay: -60,
                                            font: {
                                                color: w.theme ? 'white' : '#000000dd'
                                            },
                                            target: true,
                                            borderpad: 4,
                                            opacity: 1,
                                            visible: true,
                                        }
                                        annotation = {
                                            ...annotation,
                                            ...annotationMod
                                        }
                                    }
                                    w.layout.scene.annotations.push(annotation);
                                }
                            })
                            if (existingAnnotations.length > 0 && w.data[0].id) {
                                existingAnnotations.map(anno => {
                                    let index = w.data[0].id.findIndex(id => id === anno.id)
                                    if (index >= 0) {
                                        anno.captureevents = w.switches.editPCA ? true : false
                                        if (d[index] != undefined) {
                                            let distance = (parseFloat(d[index]) * 100).toFixed(2)
                                            let text = `>distance: ${distance}<`
                                            anno.text = anno.text.replace(/>distance: .*?</, text)
                                        }
                                        anno.x = x[index]
                                        anno.y = y[index]
                                        anno.z = z[index]
                                        anno.xanchor = "top"
                                        anno.font = {
                                            color: w.theme ? 'white' : '#000000dd'
                                        }
                                        anno.bgcolor = w.theme ? "#00000055" : "#f2f2f2aa"
                                        anno.bordercolor = w.theme ? "#f2f2f211" : '#00000011'
                                        w.layout.scene.annotations.push(anno);
                                    }
                                })
                            }
                            w.startedPlotly = Date.now()
                        } else {
                            w.config = {
                                responsive: true,
                                displaylogo: false,
                                scrollZoom: true
                            }
                            w.layout = {
                                mode: '2d',
                                init: true,
                                'paper_bgcolor': '#f2f2f2',
                                'plot_bgcolor': '#f2f2f2',
                                annotations: [],
                                local: true,
                                itemsizing: 'trace',
                                //legend: { x: 1.25, y: 1, itemclick: false, xanchor: 'right' },
                                margin: {
                                    l: 80,
                                    r: 0,
                                    b: 80,
                                    t: 35,
                                    pad: 5
                                },
                                title: {
                                    text: existingTitle ? existingTitle : '2D PCA ' + name + averaged + ` (${w.modes.find( x => x.value == w.modetype)['label']})`,
                                    font: {
                                        color: 'black'
                                    },
                                    xanchor: w.screenWidth < 620 ? 'center' : 'left',
                                    x: w.screenWidth < 620 ? null : 0.065,
                                    //y: w.screenWidth < 620 ?  0.95 : 0.93,
                                    y: 0.09,
                                    yanchor: 'bottom'
                                },
                                hovermode: 'closest',
                                xaxis: {
                                    title: {
                                        text: "PC1 (" + (variances[0] * 100).toFixed(2) + "%)",
                                        standoff: 20
                                    },
                                    spikecolor: '#1fe5bd',
                                    zeroline: true,
                                    zerolinecolor: '#1fe5bd',
                                    spikemode: 'across',
                                    spikedash: 'solid',
                                    spikethickness: 1
                                },
                                yaxis: {
                                    title: {
                                        text: "PC2 (" + (variances[1] * 100).toFixed(2) + "%)",
                                        standoff: 7
                                    },
                                    zeroline: true,
                                    zerolinecolor: '#1fe5bd',
                                    spikecolor: '#1fe5bd',
                                    spikemode: 'across',
                                    spikedash: 'solid',
                                    spikethickness: 1
                                },
                            }
                            let newdata = [];
                            let newtraces = {};
                            c.map((grp, i) => {
                                //grp = c.map((group, i) => w.rawtext.findIndex(x => x.indexOf(group + ' ►') >= 0) >= 0 ? ids[i].replace(/:/, ' ► ').replace(/_/g, ' ').split('|')[0].split('@')[0] : group.split('|')[0]),
                                grp = w.rawtext.findIndex(x => x.replace(/ ► /g, ':').replace(/ /g, '_') == ids[i].replace(/ /g, '_')) >= 0 ? ids[i].split(':')[1].replace(/_/g, ' ') : grp.split('|')[0]
                                grp = grp.split('|')[0]
                                if (!newtraces[grp]) {
                                    newtraces[grp] = {
                                        type: 'scatter',
                                        hoverinfo: 'text',
                                        x: [],
                                        y: [],
                                        d: [],
                                        id: [],
                                        name: grp,
                                        line: {
                                            opacity: 0.1
                                        },
                                        mode: 'markers',
                                        marker: {
                                            line: {
                                                color: 'white',
                                                width: 2,
                                                opacity: 1
                                            },
                                            size: [],
                                            opacity: 0.9
                                        },
                                        text: []
                                    };
                                    //newtraces[grp] = {type: 'scatter', x: [], y: [], name: grp, mode: 'markers', marker: { symbol: [], size: 14}, text: []};
                                }
                                newtraces[grp]['x'].push(-1 * x[i])
                                newtraces[grp]['y'].push(-1 * y[i])
                                newtraces[grp]['d'].push(d[i])
                                newtraces[grp]['text'].push(t[i])
                                newtraces[grp]['id'].push(ids[i])
                                if (textArray[i] === 'Average' || o[i] == 'x') {
                                    let annotation = {
                                        clicked: false,
                                        captureevents: w.switches.editPCA ? true : false,
                                        text: o[i] == 'x' ? t[i].split(' ► ')[1] : `<b>${c[i].split('|')[0]}</b>`,
                                        x: -1 * x[i],
                                        y: -1 * y[i],
                                        xref: "x",
                                        yref: "y",
                                        id: ids[i],
                                        showarrow: true,
                                        arrowhead: 7,
                                        arrowsize: 1,
                                        arrowwidth: 1,
                                        arrowcolor: '#00000000',
                                        ax: 0,
                                        ay: -20,
                                        font: {
                                            color: w.theme ? 'white' : '#000000dd'
                                        },
                                        bgcolor: w.theme ? "#00000055" : "#f2f2f2aa",
                                        borderpad: 3,
                                        borderradius: 5,
                                        visible: w.switches.all ? true : false,
                                        bordercolor: w.theme ? "#f2f2f211" : '#00000011'
                                    }
                                    if (w.runPCA) {
                                        annotation.auto = true;
                                    }
                                    if (o[i] == 'x') {
                                        let annotationMod = {
                                            bgcolor: "#f2f2f2aa",
                                            text: `<b>${t[i].split(' ► ')[1]}</b>`,
                                            bordercolor: w.theme ? '#ffffff55' : '#00000011',
                                            arrowcolor: w.theme ? '#ddd' : '#00000055',
                                            ax: 0,
                                            ay: -60,
                                            font: {
                                                color: w.theme ? 'white' : '#000000dd'
                                            },
                                            target: true,
                                            borderpad: 4,
                                            opacity: 1,
                                            visible: true,
                                        }
                                        annotation = {
                                            ...annotation,
                                            ...annotationMod
                                        }
                                    }
                                    if (x[i] && y[i]) w.layout.annotations.push(annotation);
                                }
                                if (Array.isArray(newtraces[grp]['marker']['size'])) newtraces[grp]['marker']['size'].push(s[i])
                                if (o[i] === 'x') {
                                    newtraces[grp]['marker'].symbol = 32
                                    newtraces[grp]['marker'].line.width = 2
                                    newtraces[grp]['marker'].line.color = '#fff'
                                    newtraces[grp]['marker'].opacity = 1
                                    newtraces[grp]['marker'].size = 15
                                    newtraces[grp]['marker'].color = w.colors[w.colorindex]
                                    w.colorindex = w.colorindex + 1 % w.colors.length
                                    //if (w.runPCA) {
                                    let annotation = {
                                        clicked: false,
                                        captureevents: w.switches.editPCA ? true : false,
                                        text: `${c[i].split('|')[0]}`,
                                        x: -1 * x[i],
                                        y: -1 * y[i],
                                        xref: "x",
                                        yref: "y",
                                        id: ids[i],
                                        showarrow: true,
                                        arrowhead: 7,
                                        arrowsize: 1,
                                        arrowwidth: 1,
                                        arrowcolor: '#00000000',
                                        ax: 0,
                                        ay: -20,
                                        font: {
                                            color: w.theme ? 'white' : '#000000dd'
                                        },
                                        bgcolor: w.theme ? "#00000055" : "#f2f2f2aa",
                                        borderpad: 3,
                                        borderradius: 5,
                                        visible: w.switches.all ? true : false,
                                        bordercolor: w.theme ? "#f2f2f211" : '#00000011'
                                    }
                                    annotation.text = `<b>${annotation.text}</b>`
                                    annotation.font = {
                                        color: w.theme ? '#66a3e0' : '#a10000'
                                    }
                                    annotation.auto = true;
                                    //w.layout.annotations.push(annotation)
                                    //}
                                }
                            })
                            Object.keys(newtraces).map(trace => newdata.push(newtraces[trace]))
                            if (existingAnnotations.length > 0) {
                                existingAnnotations.map(anno => {
                                    let groupindex = newdata.findIndex(group => group.id && group.id.indexOf(anno.id) >= 0)
                                    if (groupindex >= 0) {
                                        let index = newdata[groupindex].id.findIndex(id => id === anno.id)
                                        if (index >= 0) {
                                            let obj = {
                                                id: anno.id,
                                                x: anno.x,
                                                y: anno.y
                                            }
                                            let text = anno.text
                                            if (newdata[groupindex].d && newdata[groupindex].d[index] != undefined) {
                                                let distance = (parseFloat(newdata[groupindex].d[index]) * 100).toFixed(2)
                                                text = `>distance: ${distance}<`
                                                anno.text = anno.text.replace(/>distance: .*?</, text)
                                            }
                                            anno.captureevents = w.switches.editPCA ? true : false
                                            anno.x = anno.t ? -1 * newdata[groupindex].x[index] : newdata[groupindex].x[index]
                                            anno.y = anno.t ? -1 * newdata[groupindex].y[index] : newdata[groupindex].y[index]
                                            anno.font = {
                                                color: w.theme ? 'white' : '#000000dd'
                                            }
                                            anno.bgcolor = w.theme ? "#00000055" : "#f2f2f2aa"
                                            anno.bordercolor = w.theme ? "#f2f2f211" : '#00000011'
                                            obj = {
                                                id: anno.id,
                                                x: anno.x,
                                                y: anno.y,
                                                datax: newdata[groupindex].x[index],
                                                datay: newdata[groupindex].y[index],
                                                data: newdata[groupindex]
                                            }
                                            w.layout.annotations.push(anno);
                                        }
                                    }
                                })
                            }
                            w.startedPlotly = Date.now()
                            //w.redraw = true
                            w.runPCA = false;
                            w.data = newdata;
                        }
                    } catch (err) {
                        console.log(err)
                        w.spinner = false
                        w.runPCA = false;
                        return
                    }
                }, 300)
            }
        },
        afterPlot() {
            let w = this;
            this.plotId = Date.now();
            w.runCalc = false;

            function attachTooltip() {
                if (d3 && w.mode == '2d') {
                    let timeout
                    let tooltip
                    var legend = d3.select('g.legend')
                    d3.selectAll('.d3tooltip').remove();
                    var items = legend.selectAll('g.traces');
                    timeout = setTimeout(() => {
                        items.on('mouseover', (d) => {
                            tooltip = d3.select("body").append("div")
                                .attr("class", "d3tooltip")
                                .style("opacity", 0);
                            d = d[0];
                            let term = d.trace && d.trace.name && d.trace.name.split(' ► ').length > 1 ? (d.trace.name.split(' ► ')[1] == 'Average' ? d.trace.name.split(' ► ')[0] : d.trace.name.split(' ► ').join(':')) : d.trace && d.trace.name ? d.trace && d.trace.name : ''
                            let data = w.data.find(x => x.name === d.trace.name)
                            if (data && data.d && data.d[0] !== undefined && data.d[0] !== null) {
                                let distance = (100 * data.d[0]).toFixed(2)
                                tooltip.transition()
                                    .duration(300)
                                    .style("opacity", .5);
                                tooltip.html(`&nbsp;distance ${distance}&nbsp;<br/>`)
                                    .style("left", ((d3.event.pageX) - 120) + "px")
                                    .style("top", (d3.event.pageY - 20) + "px");
                            }
                            w.debounceSearch(term.replace(/ /g, '_'))
                        }, 300)
                    });
                    items.on('click', () => {
                        if (tooltip) tooltip.remove();
                    })
                    items.on('mouseout', () => {
                        PlotlyInstance.Fx.unhover('pcaDiv', w.hoverPoints)
                        if (tooltip) tooltip.remove();
                        d3.selectAll('.d3tooltip').remove();
                        clearTimeout(timeout)
                    })
                } else if (d3 == 1) {
                    let timeout
                    let tooltip
                    let d3 = PlotlyInstance.d3
                    var legend = d3.select('g.legend')
                    var items = legend.selectAll('g.traces');
                    timeout = setTimeout(() => {
                        items.on('mouseover', (d) => {
                            tooltip = d3.select("body").append("div")
                                .attr("class", "d3tooltip")
                                .style("opacity", 0);
                            d = d[0];
                            let width = 60;
                            let height = 30;
                            let margin = {
                                left: 10,
                                right: 10,
                                top: 10,
                                bottom: 10
                            }
                            let term = d.trace && d.trace.name && d.trace.name.split(' ► ').length > 1 ? (d.trace.name.split(' ► ')[1] == 'Average' ? d.trace.name.split(' ► ')[0] : d.trace.name.split(' ► ').join(':')) : d.trace && d.trace.name ? d.trace && d.trace.name : ''
                            let name = d.tx.split('<')[0]
                            let dataindex = w.data[0].id.findIndex(x => x == name.replace(/ ► /, ':').replace(/ /g, '_'))
                            if (dataindex !== undefined && w.data[0].d && w.data[0].d[dataindex] !== undefined) {
                                let distance = (100 * w.data[0].d[dataindex]).toFixed(2)
                                tooltip.transition()
                                    .duration(200)
                                    .style("opacity", .5);
                                tooltip.html(`&nbsp;distance ${distance}&nbsp;<br/>`)
                                //.style("left", ((d3.event.pageX) - 120) + "px")
                                //.style("top", (d3.event.pageY - 20) + "px");
                            }
                        }, 300)
                    });

                    items.on('mousemove', () => {
                        if (tooltip) tooltip.remove();
                        clearTimeout(timeout)
                    })
                    items.on('mouseout', () => {
                        if (tooltip) tooltip.remove();
                        clearTimeout(timeout)
                    })
                }
            }
            attachTooltip()
            this.done = Date.now()
            setTimeout(() => {
                this.saveReady = true;
                if (this.searchterm && this.searchterm.length > 0 && !this.annotationCLicked) {
                    setTimeout(() => {
                        this.annotationCLicked = false
                        this.debounceSearch()
                    }, 2000)
                } else {
                    this.annotationCLicked = false;
                }
            }, 0)
            this.titleText = this.layout.title.text
            if (this.startedPlotly && this.startedLoad) {
                console.log('elapsed prep', parseInt((this.startedPlotly - this.startedLoad) / 1))
                console.log('elapsed plot', parseInt((this.done - this.startedPlotly) / 1))
            }
            this.redraw = false;
            setTimeout(() => {
                this.pcaClass = "ready"
            }, 0)
            //this.layout.rerun = false;
            this.spinner = false
        },
        getJSON: async function() {
            try {
                let groups = this.customGroupModel && this.customGroupModel.length > 0 ? this.customGroupModel.map(x => x.label) : false
                this.runCalc = this.customGroupModel[0] && this.customGroupModel[0].calculator ? true : false
                let samples = []
                let calculator = false;
                let personalSamples = []
                if (this.modetype !== 'G25') {
                    groups.map((x, i) => {
                        let rawgroup = x + '|' + this.modetype;
                        if (this.customGroupModel[i].calculator) {
                            calculator = `${this.customGroupModel[i].user}|${this.customGroupModel[i].calculator}`
                        } else {
                            samples.push(rawgroup)
                        }
                    })
                } else {
                    groups.map((x, i) => {
                        let g25group = this.groupOptions.find(g => g.label === x || g.group === x)
                        g25group = g25group && g25group.v ? x + '|' + g25group.v : x
                        if (this.customGroupModel[i].calculator) {
                            calculator = `${this.customGroupModel[i].user}|${this.customGroupModel[i].calculator}`
                        } else {
                            samples.push(g25group)
                        }
                        samples.push(g25group);
                    })
                }
                if (this.switches.averaged) samples = samples.map(x => x.split(':').length === 1 && x.split(' [').length === 1 ? x + ':Average' : x.split(':').length === 1 && x.split(' [').length === 2 ? `${x.split(' [')[1].replace(/\]/,'').split('|')[0]}:${x.split(' [')[0]}_Average@${this.modetype}` : x)
                if (this.sampleModel.length > 0) {
                    this.sampleModel.map(x => {
                        let group = x.v ? x.group + '|' + x.v : x.group
                        samples.push(`${group}:${x.sample}`)
                        personalSamples.push(`${group}:${x.sample}`)
                    })
                }
                let interested = false
                if (this.interestedModel.length > 0) {
                    let sample = this.interestedModel[0]
                    if (sample.type === 'G25') {
                        sample = sample.v ? sample.group + '|' + sample.v + ':' + sample.sample : sample.group + ':' + sample.sample
                        samples.push(sample);
                        interested = sample
                    } else {
                        sample = sample.type === 'raw' ? sample.group + '|' + this.modetype + ':' + sample.sample : sample.group + ':' + sample.sample
                        samples.push(sample);
                        interested = sample
                    }
                }
                let dataset = await this.getLiveData({
                    samples: samples,
                    calculator: calculator,
                    personal: personalSamples,
                    interested: interested
                });
                let interestedDistances = dataset.interested && dataset.interested.length > 0 ? this.calculateDistances({
                    dataset: dataset,
                    interested: dataset.interested
                }) : undefined
                if (interestedDistances) dataset.interestedDistances = interestedDistances
                let pcadata = await this.PCA(dataset)
                let output = this.outputProcessor(pcadata, interestedDistances, samples);
                return output
            } catch (err) {
                console.log(err);
            }
        },
        setSelectedGroup: function(e, b) {
            if (e.id.split(':').length > 1 && e.params) {
                console.log('rerunning', e.label)
                setTimeout(() => {
                    this.rerun(e.params, true)
                }, 0)
            }
            if (e.id && e.id.split(':')[1] || e.id && e.history) {
                if (this.$refs.tree.getCheckedNodes()[0] === e) {
                    //this.$refs.tree.setCheckedNodes([{ id: '1:1' }])
                    this.$store.commit('change', {
                        plotGroupSamples: []
                    })
                } else {
                    this.rerun
                    this.$refs.tree.setCheckedNodes([e])
                    this.$store.commit('change', {
                        plotGroupSamples: [e]
                    })
                    this.$store.commit('change', {
                        plotCustomGroups: []
                    })
                }
            } else if (this.$refs.tree.getCheckedNodes().length > 1) {
                console.log(3, e)
                this.$refs.tree.setCheckedKeys([e.id])
                this.$store.commit('change', {
                    plotGroupSamples: [e]
                })
                this.$store.commit('change', {
                    plotCustomGroups: []
                })
            } else {
                console.log(4, e)
                this.groupModel = []
            }
            let prefix = this.user.username + ':plot:'
            localStorage.setItem(prefix + 'multiselect:customGroupModel', JSON.stringify(this.customGroupModel))
            localStorage.setItem(prefix + 'groupModel', JSON.stringify(this.groupModel))
        },
        annotate: function(annotation) {
            let index = annotation.index
            let text = annotation.text
            let layout = JSON.parse(JSON.stringify(this.layout))
            let annotations = this.mode === '2d' ? layout.annotations : layout.scene.annotations
            //annotations[index].text = annotations[index].text.replace(/<b s>.*<\/b>/, `<b s><br>${text}</b>`)
            annotations[index].text = text
            this.layout = layout;
            this.annotations = Date.now();
            //window.Plotly.relayout('pcaDiv', { annotations: annotations })
        },
        updateAnnotation: function() {
            let w = this;
            w.annotationCLicked = true
            w.editing = true;
            let args = arguments
            let index = args[0].index
            let currentText = args[0].annotation && args[0].annotation.text ? args[0].annotation.text : ''
            let buttons = [{
                    title: 'CANCEL',
                    handler: (i, event) => {
                        let text = currentText;
                        //this.annotate({ text: text, index: index })
                        this.$modal.hide('annotatemodal')
                    }
                },
                {
                    title: "OK",
                    handler: (i, event) => {
                        let text = this.$store.getters.get('annotationText');
                        if (text.length > 0) {
                            text = text.replace(/^\<p.*?\>/i, '').replace(/\<p.*?\>/ig, '<br>').replace(/\<\/p\>/ig, '')
                            this.annotate({
                                text: text,
                                index: index
                            })
                        }
                        this.$modal.hide('annotatemodal')
                    }
                }
            ]
            this.$modal.show('annotatemodal', {
                title: 'Annotate Label',
                text: currentText,
                buttons: buttons,
            })
            setTimeout(() => {
                w.editing = false;
            }, 2000)
        },
        changeCursor: function(hover) {
            let dragLayer = document.getElementsByClassName('nsewdrag')[0] || false
            if (dragLayer && dragLayer.style) {
                if (hover) {
                    dragLayer.style.cursor = 'pointer'
                } else {
                    dragLayer.style.cursor = ''
                }
            }
        },

        log: function() {
            let args = arguments;
            if (args && window.genoplotDebug) {
                console.log(args);
            } else {
                return false
            }
        },
        resetAnnotations: function() {
            let w = this;
            w.annotationCLicked = true
            if (w.mode === '2d') {
                if (w.layout && w.layout.annotations) {
                    w.layout.annotations.forEach(x => {
                        x.visible = x.clicked ? true : w.switches.all ? true : false
                    })
                    w.layout = JSON.parse(JSON.stringify(w.layout))
                    console.log('setting', this.annotations);
                    this.annotations = Date.now()
                    this.redraw = false;
                }
            } else {
                if (w.layout.scene && w.layout.scene.annotations) {
                    w.layout.scene.annotations.map(x => x.visible = x.clicked ? true : w.switches.all ? true : false)
                    w.layout = JSON.parse(JSON.stringify(w.layout))
                    this.annotations = Date.now()
                    this.redraw = false;
                }
            }
        },
        setAnnotation: function(evt) {
            let w = this;
            w.annotationCLicked = true
            let args = arguments
            if (args) {
                var pts = '';
                let data = args[0]
                let annotate_text = false;
                let id;
                let layout = JSON.parse(JSON.stringify(w.layout))
                if (w.mode === '2d' && data && data.points && data.points[0]) {
                    annotate_text = data.points[0].text || false
                    id = data.points[0].pointIndex >= 0 && data.points[0].data && data.points[0].data.id ? data.points[0].data.id[data.points[0].pointIndex] : undefined
                } else if (w.mode === '3d' && data.points && data.points[0] && data.points[0].x) {
                    let text = w.data[0].text
                    let filtered = w.data[0].x.filter(x => x === data.points[0].x)
                    let index = []
                    w.data[0].x.map((x, i) => {
                        if (x === data.points[0].x && w.data[0].y[i] === data.points[0].y && w.data[0].z[i] === data.points[0].z) index.push(i)
                    })
                    if (index.length > 0 && w.data[0].text[index[0]]) {
                        annotate_text = w.data[0].text[index[0]] || false
                        id = w.data[0] && w.data[0].id && w.data[0].id[index[0]] ? w.data[0].id[index[0]] : undefined
                    }
                } else {
                    return
                }
                if (annotate_text) {
                    w.spinner = true;
                    let annotation = {
                        captureevents: w.switches.editPCA ? true : false,
                        text: annotate_text,
                        clicked: true,
                        x: data.points[0].x,
                        y: data.points[0].y,
                        z: data.points[0].z,
                        id: id,
                        xref: "x",
                        yref: "y",
                        zref: "z",
                        showarrow: true,
                        arrowhead: 7,
                        arrowsize: 1,
                        arrowwidth: 1,
                        arrowcolor: w.theme ? "#f2f2f2aa" : '#00000055',
                        ax: 0,
                        ay: -60,
                        font: {
                            color: w.theme ? 'white' : '#000000dd'
                        },
                        bgcolor: w.theme ? "#00000055" : "#f2f2f2aa",
                        borderpad: 4,
                        borderradius: 5,
                        opacity: 1,
                        visible: true,
                        bordercolor: w.theme ? "#f2f2f211" : '#00000011'
                    }
                    if (this.mode === '2d') {
                        let index = layout.annotations.findIndex(x => x.id === id && x.clicked)
                        if (index >= 0) {
                            console.log('found annotation', layout.annotations[index])
                            layout.annotations.splice(index, 1)
                        } else {
                            console.log('new annotation', annotation)
                            if (annotate_text) layout.annotations.push(annotation);
                        }
                        w.redraw = false
                        w.layout = layout
                        w.annotations = Date.now()
                        //window.Plotly.relayout('pcaDiv', { annotations: layout.annotations })
                    } else {
                        let index = layout.scene.annotations.findIndex(x => x.id === id && x.clicked)
                        if (index >= 0) {
                            console.log('found annotation', layout.scene.annotations[index])
                            layout.scene.annotations.splice(index, 1)
                        } else {
                            console.log('new annotation', annotation)
                            if (annotate_text) layout.scene.annotations.push(annotation);
                        }
                        layout.modified = Date.now()
                        w.redraw = false;
                        w.layout = layout
                        w.annotations = Date.now()
                        //window.Plotly.relayout('pcaDiv', { annotations: layout.scene.annotations })
                    }
                    w.spinner = false;
                }
            }
        },
        setScene: function(data) {
            if (window.genoplotDebug && data && data["scene.camera"]) console.log(JSON.stringify({
                up: data["scene.camera"].up,
                center: data["scene.camera"].center,
                eye: data["scene.camera"].eye
            }))
            if (data && data["scene.camera"]) {
                this.scene = {
                    scene: {
                        camera: data["scene.camera"]
                    }
                }
                this.plotId = Date.now()
            }
        },
        getMetadata: function() {
            let metadata = this.g25data.split('\n')
                .map(x => x.split(','))
                .filter(x => !!x[0])
                .map(x => ({
                    group: x[0].split(':')[0],
                    sample: x[0].split(':')[1] || x[0].split(':')[0],
                    coords: x.slice(1)
                }))
                .map(x => ({
                    ...x,
                    clines: this.groupsCline.filter(c => c.groups.includes(x.group)).map(x => x.name),
                    ages: this.groupsAge.filter(c => c.groups.includes(x.group)).map(x => x.name)
                }));
            return metadata
        },
        PCA: async function(dataset) {
            let start = Date.now()
            const pca = new PCA(dataset.numbers);
            const json = pca
                .predict(dataset.numbers)
                .toJSON()
                .map((x, i) => ({
                    name: dataset.interestedDistancesa && dataset.interestedDistances[i] ? `(${(100 * dataset.interestedDistances[i].distance).toFixed(2)}) ${dataset.names[i]}` : dataset.names[i],
                    scores: x
                }))
            let result = {
                variances: pca.getExplainedVariance(),
                json: json,
                //json: json.map(x => ({ group: x.name.split(':')[0], sample: x.name.split(':')[1], scores: x.scores })),
                dataset
            };
            return result;
        },
        toCsv: function(data) {
            return data.map((x, i) => [x.name, ...x.scores].join(',')).join('\n');
        },
        getLiveData: async function(data) {
            let samples = data.samples;
            let interested = data.interested;
            let personal = [...data.personal];
            let calculator = data.calculator;
            let w = this;
            let resultsArr = []
            let results = {
                names: [],
                numbers: [],
                interested: false
            }
            let sampleResults = []
            let tempresults = []
            let personalResults = []
            let calcResults = []
            let received = {}
            let datasamples = []
            w.pcacustomsamples = [...w.pcacustomsamples]
            if (w.pcaRerun && w.pcacustomsamples) {
                w.pcacustomsamples.forEach((e, i) => {
                    if (e.split(':').length > 1) {
                        let group = e.split(':')[0]
                        let sample = e.split(':')[1]
                        if (w.sampleModel.findIndex(z => z.group == group && z.sample == sample) < 0) {
                            try {
                            w.pcacustomsamples = [...w.pcacustomsamples]
                            w.pcacustomsamples.splice(i, 1)
                            }
                            catch(err) {
                            console.log('splice err', w.pcacustomsamples, i)
                            }
                        }
                        if (w.interestedModel.findIndex(z => z.group == group && z.sample == sample) < 0) {
                            w.pcacustomsamples = [...w.pcacustomsamples] 
                            w.pcacustomsamples.splice(i, 1)
                        }
                    } else if (w.customGroupModel.findIndex(z => z.group == e) < 0) {
                        w.pcacustomsamples = [...w.pcacustomsamples]
                        w.pcacustomsamples.splice(i, 1)
                    }
                })
                if (w.pcacustomsamples.length == 0) w.pcaRerun = false;
            }
            if (w.runCalc || (w.pcaRerun && w.pcacustomsamples && w.pcacustomsamples.length > 0)) {
                let params = {
                    groups: w.runCalc ? samples : w.pcacustomsamples,
                    subId: w.user.username + Date.now(),
                    custom: w.switches.custom ? true : false,
                    mode: w.modetype !== 'G25' ? w.modetype : undefined,
                    raw: w.mode !== 'G25' ? true : false,
                    version: w.mode !== 'G25' ? undefined : w.publicGroups[0].v,
                    unscaled: false
                }
                if (w.runCalc && calculator) params.calculator = calculator
                if (w.pcaRerun) params.customsamples = w.pcaRerun
                let query = getSamplesQuery
                let results = []
                let data = await w.$apollo.query({
                    query: query,
                    variables: {
                        params: JSON.stringify(params)
                    },
                    fetchPolicy: 'network-only'
                })
                if (data && data.data.getSamples && data.data.getSamples.samples) {
                    let buffer = Buffer.from(data.data.getSamples.samples, 'base64')
                    let jsonStr = w.$zlib.unzipSync(buffer).toString()
                    datasamples = JSON.parse(jsonStr)
                    datasamples.map(x => x.coords = x.coords.join(','))
                }
                calcResults = [...datasamples]
            }
            const samplesArr = samples.map(async (sample) => {

                let params, query, type;
                if (sample.split(':').length > 1) {
                    type = personal.indexOf(sample) >= 0 ? 'personal' : 'sample';
                    params = {
                        group: sample.split(':')[0],
                        sample: sample.split(':')[1]
                    }
                    query = getGenoplotsamples
                } else {
                    type = 'group'
                    params = {
                        group: sample.split(' [').length > 1 ? sample.split(' [')[1].replace(/\]/, '').split('|')[0] : sample
                    }
                    query = queryGenoplotsamplesByGroup
                }
                let response = type === 'group' ? 'queryGenoplotsamplesByGroup' : 'getGenoplotsamples'
                let result;
                if (response === 'getGenoplotsamples' && datasamples.findIndex(x => x.group === params.group && x.sample === params.sample) >= 0) {
                    result = {
                        data: {}
                    }
                    result.data[response] = datasamples.find(x => x.group === params.group && x.sample === params.sample)
                } else if (sample.split(' [').length > 1 && w.pcacustomsamples && w.pcacustomsamples.length > 0 && w.pcacustomsamples.findIndex(y => y === sample) >= 0) {
                    let group = sample.split(' [')[1].replace(/\]/, '').split('|')[0] + '_' + sample.split(' [')[0]
                    let customgroup = datasamples.filter(s => s.group == group)
                    customgroup = customgroup.map(x => {
                        x.customgroup = sample.split(' [')[0];
                        x.group = sample.split(' [')[1].replace(/\]/, '').split('|')[0];
                        x.type = this.modetype;
                        return x
                    })
                    result = {
                        data: {
                            queryGenoplotsamplesByGroup: {
                                items: customgroup
                            }
                        }
                    }
                } else {
                    result = await w.$apollo.query({
                        query: query,
                        variables: params,
                        fetchPolicy: 'network-only'
                    })
                }
                /*
                if ( result && result.data && result.data[response]) {
                    let data = result.data[response]
                    data.items  = data.items.filter(x => x
                    */
                if (result && result.data && result.data[response]) {
                    let data = result.data[response]
                    if (data.items) {
                        let items = [...data.items]
                        if (sample.split(' [').length > 1) {
                            items = data.items.filter(c => (c.group == w.user.username || c.public == 1) && c.customgroup == sample.split(' [')[0] && c.type === this.modetype)
                        }
                        items.map(r => {
                            let group = sample.split(' [').length > 1 ? sample.split('|')[0] : r.group
                            if (!received[`${group}:${r.sample}`] && personal.indexOf(`${r.group}:${r.sample}`) < 0) {
                                let name
                                if (sample.split(' [').length > 1) {
                                    r.sample = r.sample.indexOf('Average') >= 0 ? 'Average' : r.sample.indexOf('Median') >= 0 ? 'Median' : r.sample
                                    name = group + ':' + r.sample.split('@')[0]
                                } else {
                                    name = r.group.split('|')[0] + ':' + r.sample.split('@')[0]
                                }
                                if (w.switches && w.switches.removeOutliers && !r.outlier || w.switches && !w.switches.removeOutliers) {
                                    tempresults.push({
                                        name: name,
                                        number: r.coords.split(',').map(x => parseFloat(x))
                                    })
                                    received[`${group}:${r.sample}`] = true
                                }
                                if (`${r.group}:${r.sample}` === interested) results.interested = r.coords.split(',').map(x => parseFloat(x))
                            }
                        })
                        //results.names = results.names.concat(sampleResults.names)
                        //results.numbers = results.numbers.concat(sampleResults.numbers)
                    } else {
                        let name
                        let number
                        if (!received[sample]) {
                            if (sample.split('@').length > 1 && sample.split('_').length > 1) {
                                //name = `${sample.split(':')[1].split('_')[0]} [${sample.split(':')[0]}]:${sample.split(':')[1].split('_')[1].split('@')[0]}`
                                name = `${sample.split('@')[0]}`
                            } else {
                                name = sample.split(':')[0].split('|')[0] + ':' + sample.split(':')[1].split('@')[0]
                            }
                            number = data.coords.split(',').map(x => parseFloat(x))
                            if (type === 'personal') {
                                personalResults.push({
                                    name: name,
                                    number: number
                                })
                            } else {
                                if (sample !== interested) {
                                    sampleResults.push({
                                        name: name,
                                        number: number
                                    })
                                } else {
                                    //name = name.split(':').length > 1 ? 'Reference:' +  name.split(':')[1] : name
                                    sampleResults.push({
                                        name: name,
                                        number: number
                                    })
                                }
                            }
                            received[sample] = true
                            if (sample === interested) results.interested = data.coords.split(',').map(x => parseFloat(x))
                        }
                    }
                }
            })
            try {
                const dataResults = await Promise.all(samplesArr);
                tempresults.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
                //console.log('json', w.sampleJSON)
                tempresults.map(x => {
                    //console.log('sample 1', x.name)
                    results.names.push(x.name)
                    results.numbers.push(x.number)
                })
                sampleResults.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
                sampleResults.map(x => {
                    let alias = w.sampleJSON.find(s => s.originalGroup == x.name.split(':')[0]) || w.publicSamples.find(s => s.alias && s.originalGroup == x.name.split(':')[0])
                    if (alias) {
                        //console.log('sample 2', x.name, alias)
                        x.name = alias.group + ':' + x.name.split(':')[1].replace(/_/g, ' ')
                        w.rawtext.push(x.name.replace(':', ' ► '))
                    }
                    results.names.push(x.name.replace(/_/g, ' '))
                    results.numbers.push(x.number)
                })
                personalResults.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
                personalResults.map(x => {
                    let alias = w.sampleJSON.find(s => s.originalGroup == x.name.split(':')[0]) || w.publicSamples.find(s => s.originalGroup == x.name.split(':')[0])
                    if (alias) {
                        //console.log('sample 3', x.name, alias)
                        let sample = alias.group + ':' + x.name.split(':')[1].replace(/_/g, ' ')
                        w.rawtext = w.rawtext.map(r => {
                            let newname = x.name.replace(':', ' ► ') == r ? sample.replace(':', ' ► ') : r;
                            return newname
                        })
                        x.name = sample
                    }
                    results.names.push(x.name.replace(/_/g, ' '))
                    results.numbers.push(x.number)
                })
                if (calcResults.length > 0) {
                    calcResults.forEach(x => {
                        let group = x.component ? decodeURI(x.component).trim() : x.ogroup ? x.ogroup : decodeURI(x.group).trim()
                        let sample = !x.component ? x.sample : x.group == x.component ? (x.group == x.sample ? 'Average' : x.sample) : (x.group == x.sample ? `Average` : `${x.group}_${x.sample}`);
                        let name = `${group}:${sample}`
                        let number = x.coords.split(',')
                        if (results.names.findIndex(y => y.split(':')[0] == x.ogroup && y.split(':')[1] == x.osample) < 0) {
                            results.names.unshift(decodeURI(name.replace(/\%2F/g, '/')))
                            results.numbers.unshift(number)
                        }
                    })
                }
                return results
            } catch (err) {
                console.log('dataResults err', w.pcacustomsamples)
                return resultsArr
            }
        },
        outputProcessor: function({
            variances,
            json,
            samples
        }, interestedDistances = []) {
            let x = []
            let y = []
            let z = []
            let c = []
            let t = []
            let d = []
            let grouped = []
            if (interestedDistances.length > 0 && this.switches.sort) {
                json.forEach((x, i) => {
                    let index = grouped.findIndex(y => y.group == x.name.split(':')[0])
                    let customIndex = this.customGroupModel.findIndex(y => y.label == x.name.split(':')[0])
                    if (index >= 0 && customIndex >= 0) {
                        if (x.name.split(':')[1] == 'Average') {
                            grouped[index].samples.unshift({
                                x: x.scores[0],
                                y: x.scores[1],
                                z: x.scores[2],
                                name: x.name,
                                d: interestedDistances[i].distance
                            })
                        } else {
                            grouped[index].samples.push({
                                x: x.scores[0],
                                y: x.scores[1],
                                z: x.scores[2],
                                name: x.name,
                                d: interestedDistances[i].distance
                            })
                        }
                    } else {
                        if (customIndex >= 0) {
                            grouped.push({
                                group: x.name.split(':')[0],
                                samples: [{
                                    x: x.scores[0],
                                    y: x.scores[1],
                                    z: x.scores[2],
                                    name: x.name,
                                    d: interestedDistances[i].distance
                                }]
                            })
                        } else {
                            grouped.push({
                                group: x.name,
                                samples: [{
                                    x: x.scores[0],
                                    y: x.scores[1],
                                    z: x.scores[2],
                                    name: x.name,
                                    d: interestedDistances[i].distance
                                }]
                            })
                        }
                    }
                })
                grouped.sort((a, b) => a.samples[0].d > b.samples[0].d ? 1 : a.samples[0].d < b.samples[0].d ? -1 : 0)
                grouped.forEach((group, i) => {
                    group.samples.forEach(r => {
                        x.push(r.x)
                        y.push(r.y)
                        z.push(r.z)
                        c.push(r.name.split(':')[0])
                        t.push(r.name.split(':')[1])
                        d.push(r.d)
                    })
                })
            } else {
                json.forEach((r, i) => {
                    x.push(r.scores[0])
                    y.push(r.scores[1])
                    z.push(r.scores[2])
                    c.push(r.name.split(':')[0])
                    t.push(r.name.split(':')[1])
                    if (interestedDistances.length > 0) d.push(interestedDistances[i].distance)
                })
            }
            let output = {
                variances,
                x: x,
                y: y,
                z: z,
                d: d,
                interestedDistances,
                c: c,
                t: t
            }
            return output
        },
        calculateDistances: function({
            dataset,
            interested
        }) {
            const interestedNumbers = interested
            if (interestedNumbers.length < this.modes[this.modetype]) return [];
            const distances = dataset.numbers.map((on, i) => ({
                name: dataset.names[i],
                distance: this.getEuclideanDistance(interestedNumbers, on)
            }));
            return distances;
        },
        getEuclideanDistance: function(a, b) {
            let distance = Math.pow(b.map((x, i) => Math.pow(x - a[i], 2)).reduce((acc, x) => acc + x, 0), 0.5);
            return this.modetype === 'G25' ? distance : distance / 100
        },
        multiselectInput: function(id) {},
        syncStore: function(name) {
            this.plotId = Date.now();
            var props = name.split('.')
            var prop = props[0]
            if (prop === 'switches' && props[1]) {
                let id = props[1]
                /*
                if (this.switches[id]) {
                    Object.keys(this.switches).map(x => {
                        x !== id ? this.switches[x] = false : true
                    })
                } else {
                    let switchedOn = 0;
                    Object.keys(this.switches).map(x => {
                        this.switches[x] ? switchedOn++ : false
                    })
                    if (switchedOn === 0) {
                        this.switches.all = true;
                    }
                }
                */
                if (id === 'averaged' && this[prop].averaged === true) {
                    this[prop].removeOutliers = false;
                    this.surface = false;
                }
                if (id === 'removeOutliers' && this[prop].removeOutliers === true) {
                    this[prop].averaged = false;
                }
                var name = this.user.username + ':plot:switches'
                var switches = {
                    plotSwitches: this.switches
                }
                this.$store.commit('change', switches)
                localStorage.setItem(name, JSON.stringify(switches));
                let load = id === 'editPCA' || id === 'all' ? false : true
                if ((id === 'all' || id === 'editPCA') && this.layout) this.resetAnnotations();
                if (this.data && this.data.length > 0 && load) {
                    this.loadPCA(true)
                }
                if (id === 'editPCA' && this.layout) {
                    let annotations = this.mode === '2d' ? this.layout.annotations : this.layout.scene.annotations
                    if (annotations) {
                        annotations.map(x => x.captureevents = this.switches.editPCA ? true : false)
                    }
                }
            }
            if (prop === 'multiselect' && props[1]) {
                let id = props[1]
                let name = this.user.username + ':plot:multiselect:' + id
                localStorage.setItem(name, JSON.stringify(this[id]));
                if (id === 'customGroupModel') {
                    if (this.customGroupModel.length > 0) {
                        //this.$refs.tree.setCheckedNodes([])
                        this.$store.commit('change', {
                            plotGroupSamples: []
                        })
                        name = this.user.username + ':plot:plotGroupSamples'
                        localStorage.setItem(name, JSON.stringify(this.groupModel))
                    }
                }
            }
        },
        customSample({
            group,
            sample,
            alias,
            age,
            origin,
            ethnicity,
            type,
            outlier,
            variability
        }) {
            group = alias ? alias : group
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                group = alias ? alias : group
                origin = origin === null || typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                var message = group + ' ► ' + (sample.split('@')[0]) + outlier + ' ( ' + age + ' ' + origin + ' )'
                //if (type === 'user') message = (ethnicity ? ethnicity + ' (U) ► ' : 'User ► ') + message
                if (type === 'user') message = (ethnicity ? `User (${ethnicity}) ` : 'User ► ') + message
                return message.replace(/_/g, ' ')
            } else {
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                return (group + ' ► ' + sample.split('@')[0] + outlier).replace(/_/g, ' ')
            }
        },
        customSample2({
            group,
            sample,
            age,
            origin,
            ethnicity,
            type,
            outlier,
            variability
        }) {
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null || typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                var message = group + ' ► ' + sample.split('@')[0] + outlier + ' ( ' + age + ' ' + origin + ' )'
                if (type === 'user') message = (ethnicity ? `User(${ethnicity} ` : 'User ► ') + message
                return message.replace(/_/g, ' ')
            } else {
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                return (group + ' ► ' + sample.split('@')[0] + outlier).replace(/_/g, ' ')
            }
        },
        customLabel({
            label,
            age,
            origin,
            v,
            outlier,
            user
        }) {
            if (this.calculator) return `${unescape(label)} by ${user}`
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ").split('@')[0] + ' ( ' + age + ' ' + origin + ' )' + outlier).replace(/:/, ' ► ')
            } else {
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ").split('@')[0] + outlier + origin).replace(/:/, ' ► ')
            }
        },
        editSamples: function(event) {
            this.$modal.show('SamplesModal', {
                groupOptions: this.groupJSON,
                showNonRawUploadIcons: this.showNonRawUploadIcons
            });
            return;
        },
        changeTheme: function() {
            if (this.plotlyTheme === 'white') {
                this.plotlyTheme = 'dark'
            } else {
                this.plotlyTheme = 'white'
            }
        }
    },
    components: {
        Social,
        SamplesModal,
        [Input.name]: Input,
        EditSamplesModal,
        Plotly,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        rightpanel,
        Collapse,
        VueSlider,
        [Switch.name]: Switch,
    },
}

function tokenize(inputStr) {
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const tokens = [];
    let match;
    while ((match = regex.exec(inputStr)) !== null) {
        if (match[1]) {
            tokens.push(match[1]);
        } else if (match[2]) {
            tokens.push(match[2]);
        } else if (match[3]) {
            tokens.push(match[3]);
        }
    }
    return tokens;
}

function parseConditions(tokens, defaultField) {
    const conditions = [];
    let currentOperator = 'OR'; // Default operator in uppercase
    tokens.forEach(token => {
        const lower = token.toLowerCase();
        if (lower === 'and' || lower === 'or') {
            currentOperator = lower.toUpperCase();
        } else {
            const parts = token.split(':');
            let field, value;
            if (parts.length === 3) {
                field = parts[0].toLowerCase();
                value = parts[1].toLowerCase();
            } else {
                field = defaultField.toLowerCase();
                value = token.toLowerCase();
            }
            conditions.push({
                field,
                value,
                operator: currentOperator
            });
            currentOperator = 'OR'; // Reset to default
        }
    });

    return conditions;
}

function getFieldValue(obj, field) {
    const fields = field.split('.');
    let value = obj;
    for (const f of fields) {
        if (value[f] === undefined || value[f] === null) {
            return '';
        }
        value = value[f];
    }
    return typeof value === 'string' ? value : String(value);
}

function buildFilterFunction(conditions) {
    return function(item) {
        let result = (conditions[0].operator === 'AND') ? true : false;

        conditions.forEach(cond => {
            const fieldValue = getFieldValue(item, cond.field).toLowerCase();
            const conditionMet1 = fieldValue == cond.value;
            const conditionMet2 = fieldValue.includes(cond.value);

            if (cond.operator === 'AND') {
                result = (result && conditionMet1 || result && conditionMet2)
            } else if (cond.operator === 'OR') {
                result = (result || conditionMet1 || conditionMet2);
            }
        });

        return result;
    };
}

function generateFilterString(conditions) {
    const filterConditions = conditions.map(cond => {
        return `item.${cond.field}.toLowerCase().includes('${cond.value}')`;
    });

    let filterString = 'const result = data.filter(item => ';

    filterConditions.forEach((cond, index) => {
        if (index === 0) {
            filterString += cond;
        } else {
            const operator = conditions[index].operator;
            filterString += ` ${operator} ${cond}`;
        }
    });

    filterString += ');';

    return filterString;
}

function filterNestedData(data, filterFunc, nestedArrayKey) {
    //console.log(data[0]);
    return data.reduce((acc, item) => {
        if (Array.isArray(item[nestedArrayKey])) {
            const filteredNested = item[nestedArrayKey].filter(filterFunc);
            if (filteredNested.length > 0) {
                acc.push({
                    ...item,
                    [nestedArrayKey]: filteredNested
                });
            }
        }
        // console.log(acc[0])
        return acc;
    }, []);
}

function filterData(inputStr, data, defaultField = 'refs', nestedArrayKey = 'samples') {
    if (!Array.isArray(data) || data.length === 0 || !inputStr || inputStr < 4) return {
        filteredData: data,
        filterString: ''
    };
    const tokens = tokenize(inputStr);
    const conditions = parseConditions(tokens, defaultField);
    const filterString = generateFilterString(conditions);
    const filterFunc = buildFilterFunction(conditions);

    const firstItem = data[0];
    const isNested = nestedArrayKey && firstItem.hasOwnProperty(nestedArrayKey) && Array.isArray(firstItem[nestedArrayKey]);

    let filteredData;
    if (isNested) {
        filteredData = filterNestedData(data, filterFunc, nestedArrayKey);
    } else {
        filteredData = data.filter(filterFunc);
    }

    return {
        filteredData,
        filterString
    };
}
